export const LogoutIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.6667 0C1.95945 0 1.28116 0.280952 0.781058 0.781049C0.280955 1.28115 0 1.95942 0 2.66667V13.3333C0 14.0406 0.280955 14.7189 0.781058 15.219C1.28116 15.719 1.95945 16 2.6667 16H7.1112C7.34695 16 7.57304 15.9064 7.73974 15.7397C7.90644 15.573 8.00009 15.3469 8.00009 15.1111C8.00009 14.8754 7.90644 14.6493 7.73974 14.4826C7.57304 14.3159 7.34695 14.2222 7.1112 14.2222H2.6667C2.43095 14.2222 2.20485 14.1286 2.03815 13.9619C1.87145 13.7952 1.7778 13.5691 1.7778 13.3333V2.66667C1.7778 2.43092 1.87145 2.20483 2.03815 2.03813C2.20485 1.87143 2.43095 1.77778 2.6667 1.77778H7.1112C7.34695 1.77778 7.57304 1.68413 7.73974 1.51743C7.90644 1.35073 8.00009 1.12464 8.00009 0.888889C8.00009 0.653141 7.90644 0.427049 7.73974 0.26035C7.57304 0.0936505 7.34695 0 7.1112 0H2.6667Z"
        fill={props.color}
      />
      <path
        d="M10.9272 3.81591C11.0939 3.64927 11.32 3.55566 11.5557 3.55566C11.7914 3.55566 12.0175 3.64927 12.1841 3.81591L15.7397 7.37147C15.9064 7.53816 16 7.76421 16 7.99991C16 8.23561 15.9064 8.46167 15.7397 8.62836L12.1841 12.1839C12.0165 12.3458 11.792 12.4354 11.5589 12.4334C11.3258 12.4314 11.1029 12.3379 10.9381 12.1731C10.7733 12.0083 10.6798 11.7853 10.6778 11.5523C10.6757 11.3192 10.7653 11.0947 10.9272 10.927L12.9655 8.8888H6.2223C5.98655 8.8888 5.76045 8.79515 5.59375 8.62845C5.42705 8.46175 5.3334 8.23566 5.3334 7.99991C5.3334 7.76416 5.42705 7.53807 5.59375 7.37137C5.76045 7.20468 5.98655 7.11102 6.2223 7.11102H12.9655L10.9272 5.0728C10.7606 4.90611 10.667 4.68006 10.667 4.44436C10.667 4.20865 10.7606 3.9826 10.9272 3.81591Z"
        fill={props.color}
      />
    </svg>
  );
};

export const SettingIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.34116 15.1487H6.65912C6.49107 15.1488 6.32806 15.0931 6.19713 14.9909C6.06619 14.8887 5.9752 14.7461 5.93924 14.5868L5.63935 13.24C5.2393 13.0699 4.85996 12.8573 4.50832 12.6059L3.15477 13.0241C2.99456 13.0737 2.82169 13.0686 2.66487 13.0097C2.50806 12.9508 2.37672 12.8416 2.29269 12.7003L0.948719 10.4477C0.865565 10.3062 0.834351 10.1416 0.860184 9.98068C0.886017 9.81978 0.967367 9.67214 1.09093 9.56193L2.1409 8.63258C2.09315 8.2116 2.09315 7.7868 2.1409 7.36581L1.09093 6.43861C0.967192 6.32835 0.885731 6.18059 0.859894 6.01953C0.834057 5.85847 0.865376 5.69368 0.948719 5.55215L2.28974 3.29812C2.37378 3.1568 2.50511 3.04762 2.66193 2.98871C2.81874 2.9298 2.99161 2.92471 3.15183 2.97428L4.50538 3.39249C4.68516 3.26381 4.87231 3.14371 5.06536 3.03504C5.25178 2.93353 5.44335 2.84131 5.63935 2.7591L5.93997 1.41369C5.97576 1.25441 6.06659 1.11178 6.19738 1.00946C6.32818 0.907128 6.49109 0.851246 6.65912 0.851074H9.34116C9.50918 0.851246 9.6721 0.907128 9.8029 1.00946C9.93369 1.11178 10.0245 1.25441 10.0603 1.41369L10.3639 2.75981C10.5702 2.84846 10.7721 2.94783 10.9673 3.05864C11.1493 3.16086 11.3254 3.2731 11.4949 3.39392L12.8492 2.97571C13.0093 2.92632 13.182 2.93151 13.3387 2.99041C13.4953 3.04931 13.6265 3.15838 13.7105 3.29955L15.0516 5.55358C15.2225 5.84454 15.1636 6.2127 14.9093 6.43932L13.8594 7.36867C13.9071 7.78966 13.9071 8.21446 13.8594 8.63544L14.9093 9.56479C15.1636 9.79213 15.2225 10.1596 15.0516 10.4505L13.7105 12.7046C13.6265 12.8459 13.4952 12.9551 13.3383 13.014C13.1815 13.0729 13.0087 13.078 12.8484 13.0284L11.4949 12.6102C11.1435 12.8614 10.7644 13.0738 10.3646 13.2436L10.0603 14.5868C10.0244 14.746 9.93348 14.8885 9.8027 14.9906C9.67192 15.0928 9.50908 15.1486 9.34116 15.1487ZM7.99882 12.7409C10.6172 12.7409 12.7398 10.6183 12.7398 7.99991C12.7398 5.38156 10.6172 3.25896 7.99882 3.25896C5.38047 3.25896 3.25787 5.38156 3.25787 7.99991C3.25787 10.6183 5.38047 12.7409 7.99882 12.7409Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8C2 8.53043 2.21071 9.03914 2.58579 9.41421C2.96086 9.78929 3.46957 10 4 10C4.53043 10 5.03914 9.78929 5.41421 9.41421C5.78929 9.03914 6 8.53043 6 8C6 7.46957 5.78929 6.96086 5.41421 6.58579C5.03914 6.21071 4.53043 6 4 6C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8Z"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4C10 4.53043 10.2107 5.03914 10.5858 5.41421C10.9609 5.78929 11.4696 6 12 6C12.5304 6 13.0391 5.78929 13.4142 5.41421C13.7893 5.03914 14 4.53043 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4Z"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12Z"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.7998 7.13334L10.1998 4.86667"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.7998 8.86667L10.1998 11.1333"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = (props) => (
  <svg
    width={props.size || "16"}
    height={props.size || "16"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8292_4550)">
      <path
        d="M2.66602 13.3332H5.33268L12.3327 6.33321C12.5078 6.15811 12.6467 5.95024 12.7414 5.72147C12.8362 5.4927 12.885 5.2475 12.885 4.99988C12.885 4.75225 12.8362 4.50705 12.7414 4.27828C12.6467 4.04951 12.5078 3.84164 12.3327 3.66654C12.1576 3.49145 11.9497 3.35255 11.7209 3.25779C11.4922 3.16303 11.247 3.11426 10.9993 3.11426C10.7517 3.11426 10.5065 3.16303 10.2778 3.25779C10.049 3.35255 9.84111 3.49145 9.66602 3.66654L2.66602 10.6665V13.3332Z"
        stroke={props.color || "#4E4E4E"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 4.3335L11.6667 7.00016"
        stroke={props.color || "#4E4E4E"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8292_4550">
        <rect
          width={props.size || "16"}
          height={props.size || "16"}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SupportIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1C11.866 1 15 4.13398 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13398 4.13401 1 8 1ZM8 2.07324C4.72674 2.07326 2.07324 4.72674 2.07324 8C2.07324 11.2733 4.72674 13.9267 8 13.9268C11.2733 13.9268 13.9268 11.2733 13.9268 8C13.9268 4.72673 11.2733 2.07324 8 2.07324Z"
        fill="#4E4E4E"
      />
      <path
        d="M7.33066 9.61326C7.33066 9.28913 7.40313 8.98711 7.54805 8.70718C7.69298 8.42726 7.86842 8.18785 8.07437 7.98895C8.28032 7.79006 8.48627 7.60221 8.69222 7.42541C8.89817 7.24125 9.07361 7.04236 9.21854 6.82873C9.36346 6.60773 9.43593 6.37569 9.43593 6.1326C9.43593 5.76427 9.30244 5.48435 9.03547 5.29282C8.77612 5.09392 8.43669 4.99448 8.01716 4.99448C7.17811 4.99448 6.64035 5.35175 6.40389 6.0663L5.5 5.58011C5.69069 5.06446 6.01487 4.67403 6.47254 4.40884C6.93021 4.13628 7.44889 4 8.0286 4C8.70747 4 9.28719 4.18416 9.76773 4.55249C10.2559 4.92081 10.5 5.43278 10.5 6.0884C10.5 6.39779 10.4275 6.68877 10.2826 6.96133C10.1377 7.23389 9.96224 7.46961 9.75629 7.66851C9.55034 7.8674 9.34439 8.06262 9.13844 8.25414C8.93249 8.43831 8.75706 8.64825 8.61213 8.88398C8.4672 9.11234 8.39474 9.35543 8.39474 9.61326H7.33066ZM7.85698 12C7.65103 12 7.47559 11.93 7.33066 11.7901C7.18574 11.6501 7.11327 11.4807 7.11327 11.2818C7.11327 11.0829 7.18574 10.9134 7.33066 10.7735C7.47559 10.6335 7.65103 10.5635 7.85698 10.5635C8.07056 10.5635 8.246 10.6335 8.3833 10.7735C8.52822 10.9134 8.60069 11.0829 8.60069 11.2818C8.60069 11.4807 8.52822 11.6501 8.3833 11.7901C8.246 11.93 8.07056 12 7.85698 12Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const ExclamatoryIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47676 5.99376C7.47676 5.72106 7.6978 5.5 7.97047 5.5C8.24314 5.5 8.46418 5.72106 8.46418 5.99376V9.50624C8.46418 9.77894 8.24314 10 7.97047 10C7.6978 10 7.47676 9.77894 7.47676 9.50624V5.99376Z"
        fill={props.color || "#A6A900"}
      />
      <path
        d="M7.97047 11.0125C7.6978 11.0125 7.47676 11.2336 7.47676 11.5062C7.47676 11.7789 7.6978 12 7.97047 12C8.24314 12 8.46418 11.7789 8.46418 11.5062C8.46418 11.2336 8.24314 11.0125 7.97047 11.0125Z"
        fill={props.color || "#A6A900"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7797 12.5788L15.7824 12.5835C16.4081 13.6742 15.6058 15 14.3781 15H1.62185C0.394157 15 -0.408056 13.6742 0.217591 12.5835L0.220316 12.5788L6.62856 1.80299C6.77126 1.55759 6.97573 1.35523 7.22016 1.21491C7.46595 1.0738 7.74408 1 8.02647 1C8.30886 1 8.58699 1.0738 8.83278 1.21491C9.07724 1.35525 9.28171 1.55763 9.42442 1.80304L15.7797 12.5788ZM8.40079 2.39991L14.7546 13.1732C14.9191 13.4599 14.7114 13.815 14.3781 13.815H1.62185C1.28864 13.815 1.08092 13.4599 1.24537 13.1732L7.65215 2.39991C7.68983 2.33463 7.74431 2.28037 7.81005 2.24263C7.87579 2.20489 7.95045 2.18501 8.02647 2.18501C8.10249 2.18501 8.17715 2.20489 8.24289 2.24263C8.30863 2.28037 8.36311 2.33463 8.40079 2.39991Z"
        fill={props.color || "#A6A900"}
      />
    </svg>
  );
};

export const ExclamatoryRoundIcon = (props) => {
  return (
    <svg
      width={props.width || 12}
      height={props.height || 12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.60938 3.74532C5.60938 3.5408 5.77515 3.375 5.97965 3.375C6.18415 3.375 6.34993 3.5408 6.34993 3.74532V6.37968C6.34993 6.5842 6.18415 6.75 5.97965 6.75C5.77515 6.75 5.60938 6.5842 5.60938 6.37968V3.74532Z"
        fill={props.color || "#E64539"}
      />
      <path
        d="M5.97965 7.50937C5.77515 7.50937 5.60938 7.67516 5.60938 7.87968C5.60938 8.0842 5.77515 8.25 5.97965 8.25C6.18415 8.25 6.34993 8.0842 6.34993 7.87968C6.34993 7.67516 6.18415 7.50937 5.97965 7.50937Z"
        fill={props.color || "#E64539"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11.1C8.81665 11.1 11.1 8.81665 11.1 6C11.1 3.18335 8.81665 0.9 6 0.9C3.18335 0.9 0.9 3.18335 0.9 6C0.9 8.81665 3.18335 11.1 6 11.1ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
        fill={props.color || "#E64539"}
      />
    </svg>
  );
};

export const AbhaIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 3C10.5 4.38071 9.38071 5.5 8 5.5C6.61929 5.5 5.5 4.38071 5.5 3C5.5 1.61929 6.61929 0.5 8 0.5C9.38071 0.5 10.5 1.61929 10.5 3ZM9.5 3C9.5 3.82843 8.82843 4.5 8 4.5C7.17157 4.5 6.5 3.82843 6.5 3C6.5 2.17157 7.17157 1.5 8 1.5C8.82843 1.5 9.5 2.17157 9.5 3Z"
        fill={props.color || "#959595"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.48324 15.1188C3.29113 15.9422 4.95683 15.2969 6.56993 14.417C6.84142 14.2701 7.09083 14.115 7.33592 13.9627C7.54831 13.8307 7.75747 13.7007 7.97495 13.5797C8.28665 13.7271 8.57889 13.9082 8.87119 14.0894C9.15204 14.2635 9.43293 14.4376 9.73118 14.5818C10.3638 14.9153 11.0262 15.182 11.7086 15.3781C13.2827 15.7761 15.1292 15.1586 15.7544 14.1153C16.2359 13.3194 15.9366 12.6193 15.4812 12.1103C14.9668 11.6128 14.3238 11.288 13.634 11.177C12.7394 10.9984 11.9762 11.1059 11.34 11.3066C10.9334 11.4348 10.5786 11.6011 10.2746 11.755L10.27 11.7574C10.1887 11.7986 10.1111 11.8388 10.037 11.8773C9.75847 12.0217 9.53098 12.1398 9.35368 12.1795C9.83302 11.5266 10.3982 10.8235 11.0275 10.0406C11.6013 9.32681 12.2285 8.54666 12.8926 7.67755C13.361 6.78566 12.7754 6.2774 11.9424 6.2774H4.08435C3.23868 6.2774 2.69073 6.74521 3.10818 7.65014C3.6222 8.49299 4.26868 9.2391 4.91481 9.98479C5.52595 10.6901 6.13677 11.3951 6.63488 12.1812C6.37065 12.0681 6.12238 11.9455 5.8776 11.8246C5.48794 11.6322 5.10708 11.4442 4.68463 11.3057C4.27466 11.1712 3.82552 11.0834 3.29113 11.0834C0.18212 11.0834 -1.3271 13.857 1.48324 15.1188ZM5.78175 12.8698C6.05115 13.0021 6.3192 13.1338 6.58868 13.2491C5.22047 14.0886 3.4863 14.9323 1.89772 14.2088L1.89284 14.2066C1.33711 13.957 1.12292 13.6905 1.04831 13.5314C0.983017 13.3922 0.979155 13.245 1.06643 13.0659C1.26397 12.6604 1.9911 12.0834 3.29113 12.0834C4.18064 12.0834 4.98707 12.4795 5.78175 12.8698ZM11.9685 14.4123C11.055 14.148 10.1352 13.7344 9.34218 13.2069C9.79221 13.106 10.1968 12.9062 10.6027 12.7056C10.8309 12.5929 11.0596 12.4799 11.297 12.3842C11.8856 12.1468 12.5836 11.987 13.4382 12.1577L13.4566 12.1613L13.4752 12.1643C13.9463 12.2401 14.393 12.4594 14.7592 12.8036C14.9704 13.0489 15.077 13.3032 14.8988 13.5978L14.8967 13.6013C14.7513 13.8438 14.3805 14.144 13.7834 14.3345C13.21 14.5175 12.552 14.5564 11.9685 14.4123ZM5.79511 9.53439C6.4972 10.4097 7.20453 11.2915 7.88108 12.2795C9.39794 10.4596 11.9685 7.27774 11.9685 7.27774C11.9685 7.27774 11.9513 7.2774 11.9424 7.2774H4.08435C4.07403 7.2774 4.064 7.27753 4.05427 7.27776C4.61651 8.065 5.20395 8.79738 5.79511 9.53439Z"
        fill={props.color || "#959595"}
      />
    </svg>
  );
};

export const PatientQueueIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4481_20149)">
        <path
          d="M1.14307 14.8574H14.8574"
          stroke={props.color || "#4E4E4E"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66699 14.8569V2.66639C2.66699 2.26225 2.82754 1.87466 3.11331 1.58889C3.39908 1.30312 3.78666 1.14258 4.1908 1.14258H11.8098C12.214 1.14258 12.6016 1.30312 12.8873 1.58889C13.1731 1.87466 13.3337 2.26225 13.3337 2.66639V14.8569"
          stroke={props.color || "#4E4E4E"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.71436 14.8566V11.809C5.71436 11.4048 5.8749 11.0172 6.16067 10.7315C6.44644 10.4457 6.83403 10.2852 7.23817 10.2852H8.76197C9.16611 10.2852 9.5537 10.4457 9.83947 10.7315C10.1252 11.0172 10.2858 11.4048 10.2858 11.809V14.8566"
          stroke={props.color || "#4E4E4E"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.47607 5.71484H9.52369"
          stroke={props.color || "#4E4E4E"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4.19141V7.23903"
          stroke={props.color || "#4E4E4E"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4481_20149">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RemainderIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.817 3.90893C10.7738 3.80952 10.6414 3.79268 10.5635 3.86802C10.4514 3.97639 10.328 4.07321 10.1953 4.15657C10.1296 4.19789 10.101 4.28045 10.1298 4.35259C10.3332 4.86205 10.4451 5.41796 10.4451 6C10.4451 8.45495 8.45498 10.4451 6.00002 10.4451C3.54507 10.4451 1.55493 8.45495 1.55493 6C1.55493 3.54504 3.54507 1.55491 6.00002 1.55491C6.23833 1.55491 6.47226 1.57366 6.70041 1.60977C6.77712 1.62191 6.85133 1.57584 6.87712 1.50258C6.92941 1.35405 6.99685 1.21266 7.07758 1.08027C7.13411 0.98756 7.08849 0.861831 6.9818 0.841647C6.66375 0.78148 6.33555 0.75 6 0.75C3.10051 0.75 0.75 3.10049 0.75 6C0.75 8.89951 3.10051 11.25 6 11.25C8.89949 11.25 11.25 8.89951 11.25 6C11.25 5.25679 11.0956 4.54966 10.817 3.90893Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M9.75 2.25C9.75 2.66421 9.41421 3 9 3C8.58579 3 8.25 2.66421 8.25 2.25C8.25 1.83579 8.58579 1.5 9 1.5C9.41421 1.5 9.75 1.83579 9.75 2.25Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M5.55029 3.15C5.55029 3.06716 5.61745 3 5.70029 3H6.30029C6.38314 3 6.45029 3.06716 6.45029 3.15V5.4C6.45029 5.48284 6.51745 5.55 6.60029 5.55H8.10029C8.18314 5.55 8.25029 5.61716 8.25029 5.7V6.3C8.25029 6.38284 8.18314 6.45 8.10029 6.45H5.70029C5.61745 6.45 5.55029 6.38284 5.55029 6.3V3.15Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const RefreshIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.63774 2.1995C6.33007 2.30389 5.97791 2.30479 5.71833 2.10836C5.52295 1.96052 5.46908 1.8423 5.49215 1.6084C5.52357 1.28978 5.75636 1.0268 6.05549 0.918554C7.41669 0.425983 8.90113 0.365312 10.3046 0.752039C11.8711 1.18366 13.2397 2.14603 14.1773 3.47506C14.9206 4.52875 15.3565 5.76127 15.4468 7.03557C15.5709 8.78543 15.4718 10.3255 15.2117 11.1717C15.1871 11.2518 15.1526 11.3311 15.0878 11.3842C14.899 11.5388 14.603 11.5078 14.4572 11.2911L12.3245 8.11972C12.134 7.83644 12.3387 7.45687 12.682 7.45687L13.6288 7.45687C13.8684 7.45687 14.0634 7.26218 14.042 7.02544C13.9532 6.04405 13.6081 5.09743 13.0343 4.28394C12.2836 3.21972 11.1877 2.44921 9.93332 2.10357C8.84615 1.804 7.69824 1.83969 6.63774 2.1995Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M9.36226 13.8006C9.66993 13.6962 10.0221 13.6953 10.2817 13.8918C10.477 14.0396 10.5309 14.1578 10.5079 14.3917C10.4764 14.7103 10.2436 14.9733 9.94451 15.0816C8.5833 15.5741 7.09886 15.6348 5.69545 15.2481C4.12889 14.8165 2.76025 13.8541 1.8227 12.5251C1.0794 11.4714 0.643543 10.2389 0.553168 8.96455C0.429066 7.21469 0.528186 5.67461 0.788286 4.82842C0.812904 4.74833 0.847381 4.669 0.912207 4.61591C1.10101 4.46128 1.397 4.49234 1.54276 4.70907L3.67552 7.8804C3.86604 8.16369 3.6613 8.54325 3.31798 8.54325L2.37123 8.54325C2.13159 8.54325 1.9366 8.73794 1.95802 8.97468C2.04685 9.95607 2.39187 10.9027 2.96573 11.7162C3.71643 12.7804 4.81234 13.5509 6.06667 13.8966C7.15385 14.1961 8.30175 14.1604 9.36226 13.8006Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const RotateIcon = (props) => {
  return (
    <svg
      width={props.width || "14"}
      height={props.height || "16"}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 1.8337C11.2234 0.646152 9.4897 -0.00254483 7.70033 0.000498944C6.00088 0.000374291 4.34933 0.583725 3.00266 1.66087C1.65613 2.73805 0.690298 4.24766 0.255917 5.95463C-0.178584 7.66172 -0.0573301 9.4702 0.600781 11.098C1.25901 12.726 2.4169 14.0819 3.89434 14.9545C5.37147 15.8272 7.08524 16.1675 8.76823 15.9226C10.4511 15.6776 12.0088 14.8609 13.1984 13.6C13.3328 13.4633 13.4087 13.276 13.4087 13.0806C13.4088 12.8851 13.3331 12.6978 13.1988 12.561C13.0645 12.4241 12.8828 12.3493 12.6947 12.3531C12.5066 12.357 12.328 12.4395 12.199 12.5818C11.6143 13.2058 10.9146 13.7011 10.1417 14.0384C9.36891 14.3758 8.53867 14.5482 7.70047 14.5454C6.35161 14.5454 5.03833 14.0956 3.95393 13.2623C2.86951 12.4291 2.07117 11.2559 1.67638 9.91603C1.28158 8.57619 1.31113 7.13989 1.76075 5.81864C2.21025 4.4975 3.05618 3.36095 4.17387 2.5765C5.29153 1.79206 6.622 1.40112 7.96961 1.46102C9.31715 1.52105 10.6106 2.02875 11.6597 2.90963H10.5001C10.25 2.90963 10.019 3.04817 9.89393 3.27318C9.7689 3.49818 9.7689 3.77553 9.89393 4.00052C10.019 4.22552 10.25 4.36407 10.5001 4.36407H13.3001C13.4857 4.36407 13.6637 4.28749 13.7949 4.15113C13.9263 4.01477 14 3.8297 14 3.63685V0.727844C14 0.468024 13.8665 0.227935 13.65 0.0980248C13.4334 -0.031885 13.1666 -0.031885 12.95 0.0980248C12.7335 0.227935 12.6 0.468028 12.6 0.727844V1.8337Z"
        fill={props.color || "white"}
      />
      {!props.removeDot && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.72042 9.02898L6.71038 10.0575C6.97311 10.3299 7.3291 10.4828 7.70022 10.4828C8.07133 10.4828 8.42733 10.3299 8.69005 10.0575L9.68001 9.02898C9.94216 8.75601 10.0893 8.38613 10.0893 8.00055C10.0893 7.61496 9.94215 7.24508 9.68001 6.97212L8.69005 5.94356C8.42733 5.67122 8.07133 5.51818 7.70022 5.51818C7.3291 5.51818 6.9731 5.6712 6.71038 5.94356L5.72042 6.97212C5.4583 7.24509 5.311 7.61496 5.311 8.00055C5.311 8.38613 5.45829 8.75601 5.72042 9.02898Z"
          fill={props.color || "white"}
        />
      )}
    </svg>
  );
};

export const BackArrowIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.92962 1.14142C7.00773 1.06332 7.13436 1.06332 7.21247 1.14142L7.63672 1.56567C7.71482 1.64378 7.71482 1.77041 7.63672 1.84851L1.91418 7.57108H15.7998C15.9102 7.57108 15.9998 7.66062 15.9998 7.77108V8.37108C15.9998 8.48153 15.9102 8.57108 15.7998 8.57108H1.91418L7.63672 14.2936C7.71482 14.3717 7.71482 14.4983 7.63672 14.5764L7.21247 15.0007C7.13436 15.0788 7.00773 15.0788 6.92962 15.0007L0.141421 8.2125C0.0633163 8.13439 0.0633162 8.00776 0.141421 7.92965L6.92962 1.14142Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0038 2.00774C14.0038 1.87881 13.8962 1.77429 13.7636 1.77429H11.0016L10.1439 0.996094H5.85516L4.99741 1.77429H2.23547C2.10283 1.77429 1.9953 1.87881 1.9953 2.00774V2.68972C1.9953 2.81865 2.10283 2.92318 2.23547 2.92318H5.85516L6.68102 2.10783H9.36273L10.1439 2.92318H13.7636C13.8962 2.92318 14.0038 2.81865 14.0038 2.68972V2.00774Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M5.95504 6.5001C5.94954 6.36758 6.05857 6.25723 6.19501 6.25723H6.92088C7.05352 6.25723 7.16105 6.36175 7.16105 6.49069V12.5325C7.16105 12.6615 7.05352 12.766 6.92088 12.766H6.44578C6.3169 12.766 6.211 12.6671 6.20581 12.542L5.95504 6.5001Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M9.80405 6.25723C9.94049 6.25723 10.0495 6.36758 10.044 6.5001L9.79325 12.542C9.78806 12.6671 9.68215 12.766 9.55328 12.766H9.07818C8.94554 12.766 8.83801 12.6615 8.83801 12.5325V6.49069C8.83801 6.36175 8.94554 6.25723 9.07818 6.25723H9.80405Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.28192 13.4472C3.28192 14.3032 4.05389 15.0036 4.99741 15.0036H11.0016C11.9452 15.0036 12.7171 14.3032 12.7171 13.4472L13.1351 4.13895C13.141 4.00614 13.0319 3.89531 12.8951 3.89531H3.10393C2.96718 3.89531 2.85802 4.00614 2.86399 4.13895L3.28192 13.4472ZM4.28434 12.724C4.28434 13.4272 4.89214 14.0025 5.635 14.0025H10.3623C11.1052 14.0025 11.713 13.4272 11.713 12.724L12.0506 5.05271H3.94667L4.28434 12.724Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const CircleIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" stroke={props.outline} />
    </svg>
  );
};

export const CircleWithTickIcon = (props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill={props.circleColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" stroke={props.circleOutline} />
      <path
        d="M6.35976 11.2621C6.56111 11.4566 6.88757 11.4566 7.08893 11.2621L13.1007 5.44215C13.302 5.24768 13.302 4.93238 13.1007 4.73791C12.8993 4.54344 12.5728 4.54344 12.3715 4.73791L7.08894 9.85365C6.88759 10.0481 6.56113 10.0481 6.35978 9.85365L3.62856 7.17253C3.4272 6.97806 3.10074 6.97806 2.89939 7.17253C2.69804 7.367 2.69804 7.6823 2.89939 7.87677L6.35976 11.2621Z"
        fill={props.tickColor}
      />
    </svg>
  );
};

export const CalenderIcon = (props) => {
  return (
    <svg
      width={props.width || 18}
      height={props.height || 18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99976 5C4.99976 5.13807 5.11168 5.25 5.24976 5.25H6.24976C6.38783 5.25 6.49976 5.13807 6.49976 5V0.5C6.49976 0.361929 6.38783 0.25 6.24976 0.25H5.24976C5.11168 0.25 4.99976 0.361929 4.99976 0.5L4.99976 2.5C4.99976 2.63807 4.88783 2.75 4.74976 2.75H1.5C0.809644 2.75 0.25 3.30964 0.25 4V16.5C0.25 17.1904 0.809645 17.75 1.5 17.75H16.5C17.1904 17.75 17.75 17.1904 17.75 16.5V4C17.75 3.30964 17.1904 2.75 16.5 2.75H14.875C14.7369 2.75 14.625 2.86193 14.625 3V4C14.625 4.13807 14.7369 4.25 14.875 4.25H16C16.1381 4.25 16.25 4.36193 16.25 4.5V7.5C16.25 7.63807 16.1381 7.75 16 7.75H2C1.86193 7.75 1.75 7.63807 1.75 7.5V4.5C1.75 4.36193 1.86193 4.25 2 4.25H4.74976C4.88783 4.25 4.99976 4.36193 4.99976 4.5V5ZM2 9.25C1.86193 9.25 1.75 9.36193 1.75 9.5V16C1.75 16.1381 1.86193 16.25 2 16.25H16C16.1381 16.25 16.25 16.1381 16.25 16V9.5C16.25 9.36193 16.1381 9.25 16 9.25H2Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M8.12476 3C8.12476 2.86193 8.23668 2.75 8.37476 2.75H11.25C11.3881 2.75 11.5 2.63807 11.5 2.5V0.5C11.5 0.361929 11.6119 0.25 11.75 0.25H12.75C12.8881 0.25 13 0.361929 13 0.5V5C13 5.13807 12.8881 5.25 12.75 5.25H11.75C11.6119 5.25 11.5 5.13807 11.5 5V4.5C11.5 4.36193 11.3881 4.25 11.25 4.25H8.37476C8.23668 4.25 8.12476 4.13807 8.12476 4V3Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66699 11.3333V12.6666C2.66699 13.0202 2.80747 13.3593 3.05752 13.6094C3.30756 13.8594 3.6467 13.9999 4.00033 13.9999H12.0003C12.3539 13.9999 12.6931 13.8594 12.9431 13.6094C13.1932 13.3593 13.3337 13.0202 13.3337 12.6666V11.3333"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 7.33325L8.00033 10.6666L11.3337 7.33325"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2.66666V10.6667"
        stroke="#4E4E4E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 18}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 1.71734C0.5 0.975985 1.01864 0.375 1.65842 0.375H22.3416C22.9814 0.375 23.5 0.975985 23.5 1.71734C23.5 2.45869 22.9814 3.05967 22.3416 3.05967H1.65842C1.01864 3.05967 0.5 2.45869 0.5 1.71734Z"
        fill={props.color || "#00a000"}
      />
      <path
        d="M0.5 9.00045C0.5 8.2591 1.01864 7.65811 1.65842 7.65811H14.6539C15.2937 7.65811 15.8123 8.2591 15.8123 9.00045C15.8123 9.7418 15.2937 10.3428 14.6539 10.3428H1.65842C1.01864 10.3428 0.5 9.7418 0.5 9.00045Z"
        fill={props.color || "#00a000"}
      />
      <path
        d="M1.65842 14.9403C1.01864 14.9403 0.5 15.5413 0.5 16.2827C0.5 17.024 1.01864 17.625 1.65842 17.625H6.9662C7.60597 17.625 8.12462 17.024 8.12462 16.2827C8.12462 15.5413 7.60598 14.9403 6.9662 14.9403H1.65842Z"
        fill={props.color || "#00a000"}
      />
    </svg>
  );
};

export const UserIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4172 8.41908C11.4772 7.66336 12.1685 6.42373 12.1685 5.02265C12.1685 2.72057 10.3023 0.85437 8.00024 0.85437C5.69816 0.85437 3.83196 2.72057 3.83196 5.02265C3.83196 6.42373 4.52323 7.66336 5.58331 8.41908C2.82629 9.40985 0.854614 12.0475 0.854614 15.1456H2.04555C2.04555 11.8569 4.71155 9.19093 8.00024 9.19093C11.2889 9.19093 13.9549 11.8569 13.9549 15.1456H15.1459C15.1459 12.0475 13.1742 9.40985 10.4172 8.41908ZM10.9776 5.02265C10.9776 6.66699 9.64458 7.99999 8.00024 7.99999C6.3559 7.99999 5.02289 6.66699 5.02289 5.02265C5.02289 3.37831 6.3559 2.04531 8.00024 2.04531C9.64458 2.04531 10.9776 3.37831 10.9776 5.02265Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const ConnectionIcon = (props) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5329 8.91221C13.2733 8.9169 13.016 8.96417 12.7706 9.05218L9.80134 4.27581H9.8012C10.2381 3.78945 10.474 3.14566 10.4584 2.48188C10.4427 1.81821 10.1768 1.18706 9.71749 0.723416C9.2582 0.259624 8.64178 0 7.99996 0C7.35814 0 6.74176 0.259642 6.28244 0.723416C5.82315 1.18706 5.55718 1.81821 5.54155 2.48188C5.52591 3.14569 5.7618 3.78945 6.19872 4.27581L3.22931 9.05218C2.98395 8.96417 2.72664 8.91689 2.46703 8.91221C1.85019 8.91008 1.2552 9.14801 0.799883 9.57857C0.344567 10.009 0.0624403 10.6008 0.00918366 11.2367C-0.0440589 11.8723 0.13557 12.5055 0.512522 13.0107C0.889464 13.5158 1.43619 13.8559 2.04411 13.9635C2.65217 14.0712 3.27709 13.9386 3.79497 13.5919C4.31285 13.2452 4.68583 12.7099 4.84008 12.0921H11.1599C11.3142 12.7099 11.6871 13.2452 12.205 13.5919C12.7229 13.9385 13.3478 14.0712 13.9559 13.9635C14.5638 13.8559 15.1105 13.5158 15.4875 13.0107C15.8644 12.5055 16.0441 11.8723 15.9908 11.2367C15.9376 10.6008 15.6554 10.009 15.2001 9.57857C14.7448 9.14799 14.1498 8.91007 13.533 8.91221H13.5329ZM7.99996 1.28047C8.326 1.28047 8.63876 1.41448 8.86942 1.65298C9.09996 1.89161 9.2295 2.21514 9.2295 2.55243C9.2295 2.88972 9.09996 3.21327 8.86942 3.45188C8.63874 3.69038 8.326 3.82439 7.99996 3.82439C7.67392 3.82439 7.36116 3.69038 7.1305 3.45188C6.89996 3.21325 6.77042 2.88972 6.77042 2.55243C6.77042 2.21514 6.89996 1.89159 7.1305 1.65298C7.36118 1.41448 7.67392 1.28047 7.99996 1.28047ZM2.46703 12.7281C2.14098 12.7281 1.82823 12.5941 1.59757 12.3556C1.36703 12.1169 1.23749 11.7934 1.23749 11.4561C1.23749 11.1188 1.36703 10.7953 1.59757 10.5567C1.82825 10.3182 2.14099 10.1842 2.46703 10.1842C2.79307 10.1842 3.10583 10.3182 3.33649 10.5567C3.56703 10.7953 3.69657 11.1188 3.69657 11.4561C3.69657 11.7934 3.56703 12.117 3.33649 12.3556C3.10581 12.5941 2.79307 12.7281 2.46703 12.7281ZM11.1599 10.8201H4.84004C4.73891 10.4144 4.54254 10.0409 4.26824 9.73259L7.2375 4.95621H7.23764C7.7322 5.14133 8.27383 5.14133 8.76838 4.95621L11.7377 9.73259C11.4613 10.0402 11.2627 10.4138 11.1598 10.8201H11.1599ZM13.5329 12.7281C13.2069 12.7281 12.8941 12.5941 12.6635 12.3556C12.4329 12.1169 12.3034 11.7934 12.3034 11.4561C12.3034 11.1188 12.4329 10.7953 12.6635 10.5567C12.8941 10.3182 13.2069 10.1842 13.5329 10.1842C13.859 10.1842 14.1717 10.3182 14.4024 10.5567C14.6329 10.7953 14.7625 11.1188 14.7625 11.4561C14.7625 11.7934 14.6329 12.117 14.4024 12.3556C14.1717 12.5941 13.859 12.7281 13.5329 12.7281Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const CounterIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z" />
      <path d="M20 16a8 8 0 1 0-16 0" />
      <path d="M12 4v4" />
      <path d="M10 4h4" />
    </svg>
  );
};

export const BuildingIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14H3.84615M14 14H12.6154M3.84615 14L3.84615 4.25449C3.84615 4.15313 3.90736 4.0618 4.0011 4.02326L8.57803 2.14184C8.74255 2.07421 8.92308 2.19518 8.92308 2.37306V6.69565M3.84615 14H8.92308M8.92308 14V6.69565M8.92308 14L12.6154 14M8.92308 6.69565L12.4334 7.68769C12.541 7.71812 12.6154 7.81638 12.6154 7.92827L12.6154 14"
        stroke="#4E4E4E"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const connectedClinicsIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5661_18771)">
        <path
          d="M14.2528 8.01369C14.3303 6.67116 13.9977 5.33683 13.2993 4.18765C12.6009 3.03847 11.5697 2.12876 10.3424 1.57916C9.11504 1.02957 7.74965 0.866064 6.42726 1.11033C5.10488 1.3546 3.888 1.9951 2.93802 2.94689C1.98803 3.89867 1.34983 5.11676 1.10807 6.4396C0.866299 7.76244 1.03239 9.12753 1.5843 10.3538C2.13622 11.5801 3.04788 12.6096 4.19838 13.3058C5.34887 14.002 6.68384 14.3321 8.02621 14.2521"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.44189 5.42188H13.8215"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.44189 9.84375H9.84233"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.26354 1C6.02215 2.98929 5.36401 5.28707 5.36401 7.63192C5.36401 9.97677 6.02215 12.2746 7.26354 14.2638"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00024 1C9.66616 3.66884 10.2667 6.86686 9.68254 9.95825"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5796 12.791H15.0009"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.79 10.5801V15.0014"
          stroke="#4E4E4E"
          strokeWidth="1.10532"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5661_18771">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StatusIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0617 6.3288C15.4293 6.23028 15.8104 6.44822 15.8769 6.82299C16.0198 7.62812 16.0386 8.45178 15.9315 9.26518C15.7944 10.3068 15.4535 11.3112 14.9282 12.221C14.4029 13.1308 13.7035 13.9283 12.8701 14.5678C12.2192 15.0672 11.4964 15.4628 10.7277 15.7416C10.3699 15.8714 9.99066 15.6503 9.89215 15.2827C9.79363 14.915 10.0136 14.5405 10.369 14.4043C10.9638 14.1764 11.5237 13.8635 12.031 13.4743C12.7208 12.9449 13.2997 12.2848 13.7345 11.5318C14.1692 10.7787 14.4514 9.94739 14.5649 9.08527C14.6484 8.4514 14.6394 7.81 14.5394 7.18097C14.4796 6.80506 14.694 6.42731 15.0617 6.3288Z"
        fill={props.color}
      />
      <path
        d="M2.83047 3.05149C2.56132 2.78234 2.55954 2.34339 2.85084 2.0984C3.47666 1.57208 4.18054 1.14393 4.93852 0.829972C5.90912 0.427934 6.94941 0.221008 7.99998 0.221008C9.05056 0.221008 10.0908 0.427934 11.0615 0.829972C11.8194 1.14393 12.5233 1.57208 13.1491 2.0984C13.4404 2.34339 13.4387 2.78234 13.1695 3.05149C12.9004 3.32064 12.466 3.31743 12.1704 3.0777C11.6756 2.67655 11.1246 2.3481 10.534 2.10344C9.73059 1.77067 8.86955 1.5994 7.99998 1.5994C7.13042 1.5994 6.26938 1.77067 5.466 2.10344C4.87533 2.3481 4.32434 2.67655 3.8296 3.0777C3.53395 3.31743 3.09961 3.32064 2.83047 3.05149Z"
        fill={props.color}
      />
      <path
        d="M6.10783 15.2827C6.00931 15.6503 5.63006 15.8714 5.27223 15.7416C4.50353 15.4628 3.7808 15.0673 3.12991 14.5678C2.29643 13.9283 1.59708 13.1308 1.0718 12.221C0.54651 11.3112 0.205569 10.3068 0.0684415 9.2652C-0.0386454 8.4518 -0.0197992 7.62814 0.123094 6.82301C0.189608 6.44824 0.570643 6.2303 0.938305 6.32882C1.30597 6.42733 1.52036 6.80508 1.46057 7.18099C1.36054 7.81002 1.35159 8.45141 1.43504 9.08529C1.54854 9.94741 1.83074 10.7787 2.26552 11.5318C2.7003 12.2849 3.27915 12.9449 3.96902 13.4743C4.47624 13.8635 5.03618 14.1764 5.63096 14.4043C5.9864 14.5405 6.20634 14.915 6.10783 15.2827Z"
        fill={props.color}
      />
    </svg>
  );
};

export const OptionIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="18"
        r="1.5"
        transform="rotate(-90 12 18)"
        fill={props.color || "#4E4E4E"}
      />
      <circle
        cx="12"
        cy="12"
        r="1.5"
        transform="rotate(-90 12 12)"
        fill={props.color || "#4E4E4E"}
      />
      <circle
        cx="12"
        cy="6"
        r="1.5"
        transform="rotate(-90 12 6)"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const BlockIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13.8 8C13.8 11.2033 11.2033 13.8 8 13.8C6.61448 13.8 5.34242 13.3142 4.34489 12.5036L12.5036 4.34489C13.3142 5.34242 13.8 6.61448 13.8 8ZM3.49637 11.6551L11.6551 3.49637C10.6575 2.68581 9.3855 2.2 8 2.2C4.79675 2.2 2.2 4.79675 2.2 8C2.2 9.3855 2.68581 10.6575 3.49637 11.6551Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const RequestIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.55321 2.75C1.24802 2.75 1.00061 3.00184 1.00061 3.3125C1.00061 3.62316 1.24802 3.87499 1.55321 3.87499L14.4472 3.87499C14.7524 3.87499 14.9998 3.62316 14.9998 3.3125C14.9998 3.00184 14.7524 2.75 14.4472 2.75L1.55321 2.75Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M6.15783 7.43746C5.85264 7.43746 5.60523 7.6893 5.60523 7.99996C5.60523 8.31062 5.85264 8.56246 6.15783 8.56246L14.4468 8.56246C14.752 8.56246 14.9994 8.31062 14.9994 7.99996C14.9994 7.6893 14.752 7.43746 14.4468 7.43746L6.15783 7.43746Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M1.55321 12.1249C1.24802 12.1249 1.00061 12.3768 1.00061 12.6874C1.00061 12.9981 1.24802 13.2499 1.55321 13.2499L14.4472 13.2499C14.7524 13.2499 14.9998 12.9981 14.9998 12.6874C14.9998 12.3768 14.7524 12.1249 14.4472 12.1249L1.55321 12.1249Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M1.00061 7.99996C1.00061 7.6893 1.24802 7.43746 1.55321 7.43746H3.39521C3.70041 7.43746 3.94781 7.6893 3.94781 7.99996C3.94781 8.31062 3.70041 8.56246 3.39521 8.56246H1.55321C1.24802 8.56246 1.00061 8.31062 1.00061 7.99996Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const AddIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.408551 7.33333C0.182914 7.33333 2.15235e-08 7.51625 2.15235e-08 7.74188L0 8.25812C0 8.48375 0.182914 8.66667 0.408551 8.66667H7.33333L7.33333 15.5915C7.33333 15.8171 7.51625 16 7.74188 16H8.25812C8.48375 16 8.66667 15.8171 8.66667 15.5915V8.66667H15.5915C15.8171 8.66667 16 8.48375 16 8.25812V7.74188C16 7.51625 15.8171 7.33333 15.5915 7.33333L8.66667 7.33333V0.408551C8.66667 0.182914 8.48375 5.38098e-08 8.25812 1.0762e-08L7.74188 0C7.51625 -4.30478e-08 7.33333 0.182914 7.33333 0.40855L7.33333 7.33333L0.408551 7.33333Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const DropDownArrowIcon = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29352 5.29471C4.68389 5.68443 5.31611 5.68445 5.7065 5.29476L9.49406 1.51403C9.77334 1.23525 9.77335 0.782728 9.49408 0.503935V0.503935C9.21549 0.225818 8.76431 0.22582 8.48572 0.503939L5.00032 3.98349L1.51429 0.503343C1.2357 0.225217 0.7845 0.225216 0.505903 0.503341V0.503341C0.226638 0.782131 0.226636 1.23464 0.505897 1.51343L4.29352 5.29471Z"
        fill="#959595"
      />
    </svg>
  );
};
export const ArrowIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.96628 3.06018C5.88309 2.97994 5.74819 2.97994 5.66499 3.06018L5.0624 3.64134C4.9792 3.72159 4.9792 3.85168 5.0624 3.93192L9.12988 7.85475C9.21308 7.935 9.21308 8.06509 9.12988 8.14533L5.06245 12.0681C4.97925 12.1484 4.97925 12.2785 5.06245 12.3587L5.66499 12.9398C5.74819 13.0201 5.88309 13.0201 5.96628 12.9398L10.9376 8.14529C11.0208 8.06505 11.0208 7.93495 10.9376 7.85471L5.96628 3.06018Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const DownArrowIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "13"}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.891422 7.33814C0.813317 7.26003 0.813316 7.1334 0.891421 7.05529L1.1389 6.80782C1.217 6.72971 1.34364 6.72971 1.42174 6.80782L5.67831 11.0644L5.67831 0.700183C5.67831 0.589725 5.76785 0.500183 5.87831 0.500183L6.22831 0.500183C6.33876 0.500183 6.42831 0.589726 6.42831 0.700183L6.42831 11.0644L10.6848 6.80782C10.763 6.72971 10.8896 6.72971 10.9677 6.80782L11.2152 7.05529C11.2933 7.1334 11.2933 7.26003 11.2152 7.33814L6.19473 12.3586C6.11662 12.4367 5.98999 12.4367 5.91188 12.3586L0.891422 7.33814Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const UpArrowIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "13"}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2152 5.66186C11.2933 5.73997 11.2933 5.8666 11.2152 5.94471L10.9677 6.19218C10.8896 6.27029 10.763 6.27029 10.6849 6.19218L6.42831 1.93561L6.42831 12.2998C6.42831 12.4103 6.33877 12.4998 6.22831 12.4998L5.87831 12.4998C5.76785 12.4998 5.67831 12.4103 5.67831 12.2998L5.67831 1.93561L1.42174 6.19218C1.34363 6.27029 1.217 6.27029 1.1389 6.19218L0.891421 5.94471C0.813316 5.8666 0.813316 5.73997 0.891421 5.66186L5.91188 0.641397C5.98999 0.563292 6.11662 0.563292 6.19473 0.641397L11.2152 5.66186Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.81323 12.3495C6.0817 12.6088 6.51698 12.6088 6.78545 12.3495L14.8011 4.58953C15.0696 4.33023 15.0696 3.90984 14.8011 3.65054C14.5326 3.39125 14.0973 3.39125 13.8289 3.65054L6.78547 10.4715C6.517 10.7308 6.08172 10.7308 5.81325 10.4715L2.17162 6.8967C1.90315 6.63741 1.46787 6.63741 1.1994 6.89671C0.930931 7.156 0.930928 7.5764 1.1994 7.83569L5.81323 12.3495Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const MoreIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="8" r="1" fill={props.color || "#4E4E4E"} />
      <circle cx="8" cy="8" r="1" fill={props.color || "#4E4E4E"} />
      <circle cx="12" cy="8" r="1" fill={props.color || "#4E4E4E"} />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00008 13.9653C11.2946 13.9653 13.9654 11.2945 13.9654 7.99999C13.9654 4.70546 11.2946 2.03471 8.00008 2.03471C4.70554 2.03471 2.03479 4.70546 2.03479 7.99999C2.03479 11.2945 4.70554 13.9653 8.00008 13.9653Z"
        fill="#4E4E4E"
      />
      <path
        d="M7.99957 5.43646C7.79362 5.43646 7.61818 5.36648 7.47325 5.22652C7.32832 5.08655 7.25586 4.91713 7.25586 4.71823C7.25586 4.51934 7.32832 4.34991 7.47325 4.20994C7.61818 4.06998 7.79362 4 7.99957 4C8.21314 4 8.38858 4.06998 8.52588 4.20994C8.67081 4.34991 8.74327 4.51934 8.74327 4.71823C8.74327 4.91713 8.67081 5.08655 8.52588 5.22652C8.38858 5.36648 8.21314 5.43646 7.99957 5.43646Z"
        fill="#4E4E4E"
      />
      <path d="M8.59127 7.01083H7.40918V12H8.59127V7.01083Z" fill="#4E4E4E" />
    </svg>
  );
};

export const PinIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.799 0.400004C11.02 0.179065 11.3783 0.17911 11.5994 0.400106L15.5996 4.3999C15.8207 4.62101 15.8207 4.97953 15.5995 5.20058C15.3784 5.42152 15.0201 5.42148 14.7991 5.20048L10.7989 1.20068C10.5777 0.979577 10.5778 0.621054 10.799 0.400004Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3984 2.39941L9.59961 1.59912L8.40018 0.400055C8.17914 0.179081 7.82084 0.179054 7.59976 0.399994C7.37857 0.621053 7.37851 0.979587 7.59964 1.20071L8.09172 1.6928C8.48225 2.08332 8.48225 2.71648 8.09172 3.10701L5.37956 5.81917C5.25627 5.94246 5.10289 6.03137 4.93463 6.07709L1.03024 7.13786C0.879879 7.17871 0.742806 7.25814 0.6326 7.36827C0.283249 7.71741 0.283144 8.28367 0.632365 8.63294L2.89276 10.8936C3.28318 11.2841 3.28323 11.9171 2.89287 12.3076L0.799698 14.4018C0.579112 14.6225 0.579044 14.9801 0.799545 15.2009C1.02025 15.4219 1.37833 15.422 1.5992 15.2012L3.69343 13.1076C4.08391 12.7173 4.71688 12.7172 5.10739 13.1076L7.3715 15.3708C7.71968 15.7188 8.28409 15.7187 8.63209 15.3705C8.74261 15.2599 8.82209 15.1222 8.86257 14.9712L9.91306 11.0522C9.9585 10.8827 10.0478 10.7281 10.1719 10.604L12.8809 7.89499C13.2714 7.50451 13.9045 7.50446 14.295 7.89488L14.8011 8.40085C15.022 8.6217 15.3802 8.62156 15.6009 8.40054C15.8214 8.17979 15.8214 7.82216 15.6009 7.60141L14.3887 6.3877L10.3984 2.39941ZM7.87695 14.2764L8.89554 10.469C8.94094 10.2993 9.03024 10.1446 9.15446 10.0203L12.7871 6.3877L9.59961 3.19922L5.96685 6.83245C5.8427 6.95661 5.68806 7.04589 5.51846 7.09133L1.71094 8.11133L7.87695 14.2764Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const ContinueIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 3.33333C16 1.49238 14.5076 0 12.6667 0H3.33333C1.49238 0 0 1.49238 0 3.33333V12.6667C0 14.5076 1.49238 16 3.33333 16H12.6667C14.5076 16 16 14.5076 16 12.6667V3.33333Z"
        fill="#00A000"
      />
      <path
        d="M10.1525 8.69611C10.5274 8.32121 10.5274 7.71337 10.1525 7.33847L6.41902 3.60494C6.23157 3.41749 5.92765 3.41749 5.7402 3.60494C5.55275 3.7924 5.55275 4.09632 5.7402 4.28377L8.7949 7.33847C9.1698 7.71337 9.1698 8.32121 8.7949 8.69611L5.7402 11.7508C5.55275 11.9383 5.55275 12.2422 5.7402 12.4296C5.92765 12.6171 6.23157 12.6171 6.41902 12.4296L10.1525 8.69611Z"
        fill="white"
      />
    </svg>
  );
};

export const SelectAllIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_54_5170" fill="white">
        <path d="M4.13516 12C3.90507 12 3.67904 11.9394 3.47977 11.8244C3.28051 11.7093 3.11504 11.5439 3 11.3446H9.37839C9.89986 11.3446 10.4 11.1374 10.7687 10.7687C11.1374 10.4 11.3446 9.89986 11.3446 9.37839V3C11.5439 3.11504 11.7093 3.28051 11.8244 3.47977C11.9394 3.67904 12 3.90507 12 4.13516V9.37839C12 10.0737 11.7238 10.7405 11.2321 11.2321C10.7405 11.7238 10.0737 12 9.37839 12H4.13516Z" />
      </mask>
      <path
        d="M4.13516 12C3.90507 12 3.67904 11.9394 3.47977 11.8244C3.28051 11.7093 3.11504 11.5439 3 11.3446H9.37839C9.89986 11.3446 10.4 11.1374 10.7687 10.7687C11.1374 10.4 11.3446 9.89986 11.3446 9.37839V3C11.5439 3.11504 11.7093 3.28051 11.8244 3.47977C11.9394 3.67904 12 3.90507 12 4.13516V9.37839C12 10.0737 11.7238 10.7405 11.2321 11.2321C10.7405 11.7238 10.0737 12 9.37839 12H4.13516Z"
        fill="#F1F1F1"
      />
      <path
        d="M4.13516 12L4.13513 13H4.13516V12ZM3 11.3446V10.3446H1.26795L2.13397 11.8446L3 11.3446ZM9.37839 11.3446V12.3446V11.3446ZM11.3446 3L11.8446 2.13397L10.3446 1.26795V3H11.3446ZM12 4.13516H13V4.13513L12 4.13516ZM4.13518 11C4.08063 11 4.02703 10.9856 3.97979 10.9584L2.97976 12.6904C3.33104 12.8932 3.72951 13 4.13513 13L4.13518 11ZM3.97979 10.9584C3.93254 10.9311 3.8933 10.8918 3.86603 10.8446L2.13397 11.8446C2.33679 12.1959 2.62849 12.4876 2.97976 12.6904L3.97979 10.9584ZM3 12.3446H9.37839V10.3446H3V12.3446ZM9.37839 12.3446C10.1651 12.3446 10.9195 12.0321 11.4758 11.4758L10.0616 10.0616C9.8804 10.2428 9.63464 10.3446 9.37839 10.3446V12.3446ZM11.4758 11.4758C12.0321 10.9195 12.3446 10.1651 12.3446 9.37839H10.3446C10.3446 9.63464 10.2428 9.8804 10.0616 10.0616L11.4758 11.4758ZM12.3446 9.37839V3H10.3446V9.37839H12.3446ZM10.8446 3.86603C10.8918 3.8933 10.9311 3.93254 10.9584 3.97979L12.6904 2.97976C12.4876 2.62849 12.1959 2.33679 11.8446 2.13397L10.8446 3.86603ZM10.9584 3.97979C10.9856 4.02703 11 4.08063 11 4.13518L13 4.13513C13 3.72951 12.8932 3.33104 12.6904 2.97976L10.9584 3.97979ZM11 4.13516V9.37839H13V4.13516H11ZM11 9.37839C11 9.80846 10.8292 10.2209 10.525 10.525L11.9393 11.9393C12.6184 11.2601 13 10.3389 13 9.37839H11ZM10.525 10.525C10.2209 10.8292 9.80846 11 9.37839 11V13C10.3389 13 11.2601 12.6184 11.9393 11.9393L10.525 10.525ZM9.37839 11H4.13516V13H9.37839V11Z"
        fill="#4E4E4E"
        mask="url(#path-1-inside-1_54_5170)"
      />
      <mask id="path-3-inside-2_54_5170" fill="white">
        <path d="M6.73465 3.39672C6.72245 3.43404 6.70331 3.46849 6.67831 3.49812L4.65936 5.89729C4.63339 5.92824 4.60157 5.95331 4.56589 5.97095C4.53021 5.98859 4.49143 5.99842 4.45195 5.99982C4.41246 6.00123 4.37313 5.99419 4.33637 5.97913C4.29961 5.96407 4.26622 5.94132 4.23827 5.91229L3.08458 4.7124C3.05777 4.68451 3.0365 4.6514 3.02198 4.61496C3.00747 4.57852 3 4.53946 3 4.50002C3 4.46058 3.00747 4.42152 3.02198 4.38508C3.0365 4.34864 3.05777 4.31553 3.08458 4.28764C3.1114 4.25975 3.14324 4.23763 3.17827 4.22253C3.21331 4.20744 3.25086 4.19967 3.28879 4.19967C3.32671 4.19967 3.36426 4.20744 3.3993 4.22253C3.43434 4.23763 3.46617 4.25975 3.49299 4.28764L4.42863 5.26075L6.24453 3.10216C6.26953 3.07253 6.29989 3.04832 6.33388 3.0309C6.36788 3.01348 6.40484 3.0032 6.44266 3.00064C6.48047 2.99807 6.51841 3.00328 6.55429 3.01597C6.59017 3.02865 6.6233 3.04856 6.65178 3.07456C6.68026 3.10056 6.70354 3.13214 6.72029 3.16749C6.73704 3.20285 6.74693 3.24129 6.74939 3.28062C6.75185 3.31995 6.74685 3.3594 6.73465 3.39672Z" />
      </mask>
      <path
        d="M6.73465 3.39672C6.72245 3.43404 6.70331 3.46849 6.67831 3.49812L4.65936 5.89729C4.63339 5.92824 4.60157 5.95331 4.56589 5.97095C4.53021 5.98859 4.49143 5.99842 4.45195 5.99982C4.41246 6.00123 4.37313 5.99419 4.33637 5.97913C4.29961 5.96407 4.26622 5.94132 4.23827 5.91229L3.08458 4.7124C3.05777 4.68451 3.0365 4.6514 3.02198 4.61496C3.00747 4.57852 3 4.53946 3 4.50002C3 4.46058 3.00747 4.42152 3.02198 4.38508C3.0365 4.34864 3.05777 4.31553 3.08458 4.28764C3.1114 4.25975 3.14324 4.23763 3.17827 4.22253C3.21331 4.20744 3.25086 4.19967 3.28879 4.19967C3.32671 4.19967 3.36426 4.20744 3.3993 4.22253C3.43434 4.23763 3.46617 4.25975 3.49299 4.28764L4.42863 5.26075L6.24453 3.10216C6.26953 3.07253 6.29989 3.04832 6.33388 3.0309C6.36788 3.01348 6.40484 3.0032 6.44266 3.00064C6.48047 2.99807 6.51841 3.00328 6.55429 3.01597C6.59017 3.02865 6.6233 3.04856 6.65178 3.07456C6.68026 3.10056 6.70354 3.13214 6.72029 3.16749C6.73704 3.20285 6.74693 3.24129 6.74939 3.28062C6.75185 3.31995 6.74685 3.3594 6.73465 3.39672Z"
        fill="#F1F1F1"
      />
      <path
        d="M6.67831 3.49812L5.91407 2.85319L5.91318 2.85424L6.67831 3.49812ZM6.24453 3.10216L5.48028 2.45723L5.47929 2.45841L6.24453 3.10216ZM4.42863 5.26075L3.70778 5.95384L4.47825 6.75516L5.19386 5.9045L4.42863 5.26075ZM3.49299 4.28764L2.77214 4.98074L2.77214 4.98074L3.49299 4.28764ZM3 4.50002H2H3ZM3.08458 4.7124L3.80543 4.01931H3.80543L3.08458 4.7124ZM4.23827 5.91229L3.51742 6.60538L3.51789 6.60587L4.23827 5.91229ZM4.65936 5.89729L3.89423 5.25341L3.89338 5.25443L4.65936 5.89729ZM7.44256 4.14304C7.55169 4.01373 7.63352 3.86544 7.68518 3.70735L5.78412 3.08609C5.81139 3.00264 5.85494 2.92326 5.91407 2.8532L7.44256 4.14304ZM7.68518 3.70735C7.73683 3.5493 7.75778 3.3832 7.74743 3.2181L5.75135 3.34315C5.74593 3.25671 5.75686 3.16951 5.78412 3.08609L7.68518 3.70735ZM7.74743 3.2181C7.73709 3.05299 7.69555 2.89039 7.62402 2.7394L5.81656 3.59559C5.77853 3.51531 5.75676 3.42959 5.75135 3.34315L7.74743 3.2181ZM7.62402 2.7394C7.55247 2.58836 7.45181 2.45087 7.32595 2.33599L5.9776 3.81313C5.90871 3.75025 5.85461 3.67592 5.81656 3.59559L7.62402 2.7394ZM7.32595 2.33599C7.2 2.22102 7.05132 2.13102 6.88757 2.07314L6.221 3.95879C6.12902 3.92628 6.04659 3.8761 5.9776 3.81313L7.32595 2.33599ZM6.88757 2.07314C6.72373 2.01522 6.54941 1.99111 6.37505 2.00292L6.51027 3.99835C6.41154 4.00504 6.31308 3.99134 6.221 3.95879L6.88757 2.07314ZM6.37505 2.00292C6.20071 2.01474 6.03171 2.0621 5.87787 2.14093L6.7899 3.92087C6.70405 3.96486 6.60897 3.99166 6.51027 3.99835L6.37505 2.00292ZM5.87787 2.14093C5.72413 2.2197 5.58947 2.32784 5.48028 2.45723L7.00877 3.74708C6.94958 3.81723 6.87565 3.87694 6.7899 3.92087L5.87787 2.14093ZM5.47929 2.45841L3.66339 4.617L5.19386 5.9045L7.00976 3.74591L5.47929 2.45841ZM5.14947 4.56765L4.21384 3.59455L2.77214 4.98074L3.70778 5.95384L5.14947 4.56765ZM4.21384 3.59455C4.09605 3.47204 3.95407 3.37268 3.79495 3.30413L3.00365 5.14094C2.9146 5.10257 2.8363 5.04746 2.77214 4.98074L4.21384 3.59455ZM3.79495 3.30413C3.63572 3.23554 3.46361 3.19967 3.28879 3.19967V5.19967C3.18981 5.19967 3.0928 5.17934 3.00365 5.14094L3.79495 3.30413ZM3.28879 3.19967C3.11396 3.19967 2.94185 3.23554 2.78262 3.30413L3.57392 5.14094C3.48477 5.17934 3.38776 5.19967 3.28879 5.19967V3.19967ZM2.78262 3.30413C2.6235 3.37268 2.48152 3.47204 2.36374 3.59455L3.80543 4.98074C3.74128 5.04746 3.66297 5.10257 3.57392 5.14094L2.78262 3.30413ZM2.36374 3.59455C2.24603 3.71697 2.15464 3.8602 2.09295 4.01508L3.95101 4.75508C3.91835 4.83709 3.86951 4.91409 3.80543 4.98074L2.36374 3.59455ZM2.09295 4.01508C2.03129 4.16991 2 4.33459 2 4.50002L4 4.50002C4 4.58657 3.98365 4.67313 3.95101 4.75508L2.09295 4.01508ZM2 4.50002C2 4.66546 2.03129 4.83013 2.09295 4.98496L3.95101 4.24496C3.98365 4.32691 4 4.41347 4 4.50002L2 4.50002ZM2.09295 4.98496C2.15464 5.13985 2.24603 5.28307 2.36374 5.40549L3.80543 4.01931C3.86951 4.08595 3.91835 4.16295 3.95101 4.24496L2.09295 4.98496ZM2.36374 5.40549L3.51742 6.60538L4.95912 5.21919L3.80543 4.01931L2.36374 5.40549ZM3.51789 6.60587C3.64081 6.73354 3.78996 6.83594 3.95727 6.90448L4.71547 5.05377C4.80926 5.0922 4.89163 5.1491 4.95864 5.2187L3.51789 6.60587ZM3.95727 6.90448C4.1247 6.97308 4.30535 7.00568 4.48754 6.99919L4.41635 5.00046C4.51958 4.99678 4.62155 5.0153 4.71547 5.05377L3.95727 6.90448ZM4.48754 6.99919C4.66972 6.9927 4.84732 6.94735 5.00905 6.8674L4.12273 5.07451C4.21311 5.02983 4.31314 5.00413 4.41635 5.00046L4.48754 6.99919ZM5.00905 6.8674C5.17064 6.78751 5.31185 6.67538 5.42535 6.54014L3.89338 5.25443C3.95492 5.1811 4.0325 5.11912 4.12273 5.07451L5.00905 6.8674ZM5.4245 6.54116L7.44345 4.14199L5.91318 2.85424L3.89423 5.25341L5.4245 6.54116Z"
        fill="#4E4E4E"
        mask="url(#path-3-inside-2_54_5170)"
      />
      <path
        d="M0.375 2C0.375 1.10254 1.10254 0.375 2 0.375H8C8.89746 0.375 9.625 1.10254 9.625 2V8C9.625 8.89746 8.89746 9.625 8 9.625H2C1.10254 9.625 0.375 8.89746 0.375 8V2Z"
        stroke="#4E4E4E"
        strokeWidth="0.75"
      />
    </svg>
  );
};

export const SelectAllActiveIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_54_5172" fill="white">
        <path d="M4.13516 12C3.90507 12 3.67904 11.9394 3.47977 11.8244C3.28051 11.7093 3.11504 11.5439 3 11.3446H9.37839C9.89986 11.3446 10.4 11.1374 10.7687 10.7687C11.1374 10.4 11.3446 9.89986 11.3446 9.37839V3C11.5439 3.11504 11.7093 3.28051 11.8244 3.47977C11.9394 3.67904 12 3.90507 12 4.13516V9.37839C12 10.0737 11.7238 10.7405 11.2321 11.2321C10.7405 11.7238 10.0737 12 9.37839 12H4.13516Z" />
      </mask>
      <path
        d="M4.13516 12C3.90507 12 3.67904 11.9394 3.47977 11.8244C3.28051 11.7093 3.11504 11.5439 3 11.3446H9.37839C9.89986 11.3446 10.4 11.1374 10.7687 10.7687C11.1374 10.4 11.3446 9.89986 11.3446 9.37839V3C11.5439 3.11504 11.7093 3.28051 11.8244 3.47977C11.9394 3.67904 12 3.90507 12 4.13516V9.37839C12 10.0737 11.7238 10.7405 11.2321 11.2321C10.7405 11.7238 10.0737 12 9.37839 12H4.13516Z"
        fill="#F1F1F1"
      />
      <path
        d="M4.13516 12L4.13513 13H4.13516V12ZM3 11.3446V10.3446H1.26795L2.13397 11.8446L3 11.3446ZM9.37839 11.3446V12.3446V11.3446ZM11.3446 3L11.8446 2.13397L10.3446 1.26795V3H11.3446ZM12 4.13516H13V4.13513L12 4.13516ZM4.13518 11C4.08063 11 4.02703 10.9856 3.97979 10.9584L2.97976 12.6904C3.33104 12.8932 3.72951 13 4.13513 13L4.13518 11ZM3.97979 10.9584C3.93254 10.9311 3.8933 10.8918 3.86603 10.8446L2.13397 11.8446C2.33679 12.1959 2.62849 12.4876 2.97976 12.6904L3.97979 10.9584ZM3 12.3446H9.37839V10.3446H3V12.3446ZM9.37839 12.3446C10.1651 12.3446 10.9195 12.0321 11.4758 11.4758L10.0616 10.0616C9.8804 10.2428 9.63464 10.3446 9.37839 10.3446V12.3446ZM11.4758 11.4758C12.0321 10.9195 12.3446 10.1651 12.3446 9.37839H10.3446C10.3446 9.63464 10.2428 9.8804 10.0616 10.0616L11.4758 11.4758ZM12.3446 9.37839V3H10.3446V9.37839H12.3446ZM10.8446 3.86603C10.8918 3.8933 10.9311 3.93254 10.9584 3.97979L12.6904 2.97976C12.4876 2.62849 12.1959 2.33679 11.8446 2.13397L10.8446 3.86603ZM10.9584 3.97979C10.9856 4.02703 11 4.08063 11 4.13518L13 4.13513C13 3.72951 12.8932 3.33104 12.6904 2.97976L10.9584 3.97979ZM11 4.13516V9.37839H13V4.13516H11ZM11 9.37839C11 9.80846 10.8292 10.2209 10.525 10.525L11.9393 11.9393C12.6184 11.2601 13 10.3389 13 9.37839H11ZM10.525 10.525C10.2209 10.8292 9.80846 11 9.37839 11V13C10.3389 13 11.2601 12.6184 11.9393 11.9393L10.525 10.525ZM9.37839 11H4.13516V13H9.37839V11Z"
        fill="#4E4E4E"
        mask="url(#path-1-inside-1_54_5172)"
      />
      <path
        d="M0.3 2C0.3 1.06112 1.06112 0.3 2 0.3H8C8.93888 0.3 9.7 1.06112 9.7 2V8C9.7 8.93888 8.93888 9.7 8 9.7H2C1.06112 9.7 0.3 8.93888 0.3 8V2Z"
        fill="#00A000"
        stroke="#4E4E4E"
        strokeWidth="0.6"
      />
      <mask id="path-4-inside-2_54_5172" fill="white">
        <path d="M6.73465 3.39672C6.72245 3.43404 6.70331 3.46849 6.67831 3.49812L4.65936 5.89729C4.63339 5.92824 4.60157 5.95331 4.56589 5.97095C4.53021 5.98859 4.49143 5.99842 4.45195 5.99982C4.41246 6.00123 4.37313 5.99419 4.33637 5.97913C4.29961 5.96407 4.26622 5.94132 4.23827 5.91229L3.08458 4.7124C3.05777 4.68451 3.0365 4.6514 3.02198 4.61496C3.00747 4.57852 3 4.53946 3 4.50002C3 4.46058 3.00747 4.42152 3.02198 4.38508C3.0365 4.34864 3.05777 4.31553 3.08458 4.28764C3.1114 4.25975 3.14324 4.23763 3.17827 4.22253C3.21331 4.20744 3.25086 4.19967 3.28879 4.19967C3.32671 4.19967 3.36426 4.20744 3.3993 4.22253C3.43434 4.23763 3.46617 4.25975 3.49299 4.28764L4.42863 5.26075L6.24453 3.10216C6.26953 3.07253 6.29989 3.04832 6.33388 3.0309C6.36788 3.01348 6.40484 3.0032 6.44266 3.00064C6.48047 2.99807 6.51841 3.00328 6.55429 3.01597C6.59017 3.02865 6.6233 3.04856 6.65178 3.07456C6.68026 3.10056 6.70354 3.13214 6.72029 3.16749C6.73704 3.20285 6.74693 3.24129 6.74939 3.28062C6.75185 3.31995 6.74685 3.3594 6.73465 3.39672Z" />
      </mask>
      <path
        d="M6.73465 3.39672C6.72245 3.43404 6.70331 3.46849 6.67831 3.49812L4.65936 5.89729C4.63339 5.92824 4.60157 5.95331 4.56589 5.97095C4.53021 5.98859 4.49143 5.99842 4.45195 5.99982C4.41246 6.00123 4.37313 5.99419 4.33637 5.97913C4.29961 5.96407 4.26622 5.94132 4.23827 5.91229L3.08458 4.7124C3.05777 4.68451 3.0365 4.6514 3.02198 4.61496C3.00747 4.57852 3 4.53946 3 4.50002C3 4.46058 3.00747 4.42152 3.02198 4.38508C3.0365 4.34864 3.05777 4.31553 3.08458 4.28764C3.1114 4.25975 3.14324 4.23763 3.17827 4.22253C3.21331 4.20744 3.25086 4.19967 3.28879 4.19967C3.32671 4.19967 3.36426 4.20744 3.3993 4.22253C3.43434 4.23763 3.46617 4.25975 3.49299 4.28764L4.42863 5.26075L6.24453 3.10216C6.26953 3.07253 6.29989 3.04832 6.33388 3.0309C6.36788 3.01348 6.40484 3.0032 6.44266 3.00064C6.48047 2.99807 6.51841 3.00328 6.55429 3.01597C6.59017 3.02865 6.6233 3.04856 6.65178 3.07456C6.68026 3.10056 6.70354 3.13214 6.72029 3.16749C6.73704 3.20285 6.74693 3.24129 6.74939 3.28062C6.75185 3.31995 6.74685 3.3594 6.73465 3.39672Z"
        fill="#F5F5F5"
      />
      <path
        d="M6.67831 3.49812L5.91407 2.85319L5.91318 2.85424L6.67831 3.49812ZM6.24453 3.10216L5.48028 2.45723L5.47929 2.45841L6.24453 3.10216ZM4.42863 5.26075L3.70778 5.95384L4.47825 6.75516L5.19386 5.9045L4.42863 5.26075ZM3.49299 4.28764L2.77214 4.98073L2.77214 4.98074L3.49299 4.28764ZM3 4.50002H2H3ZM3.08458 4.7124L2.36374 5.40549L3.08458 4.7124ZM4.23827 5.91229L3.51742 6.60538L3.51789 6.60587L4.23827 5.91229ZM4.65936 5.89729L3.89423 5.25341L3.89338 5.25443L4.65936 5.89729ZM7.44256 4.14304C7.55169 4.01373 7.63352 3.86544 7.68518 3.70735L5.78412 3.08609C5.81139 3.00264 5.85494 2.92326 5.91407 2.8532L7.44256 4.14304ZM7.68518 3.70735C7.73683 3.5493 7.75778 3.3832 7.74743 3.2181L5.75135 3.34315C5.74593 3.25671 5.75686 3.16951 5.78412 3.08609L7.68518 3.70735ZM7.74743 3.2181C7.73709 3.05299 7.69555 2.89039 7.62402 2.7394L5.81656 3.59559C5.77853 3.51531 5.75676 3.42959 5.75135 3.34315L7.74743 3.2181ZM7.62402 2.7394C7.55247 2.58836 7.45181 2.45087 7.32595 2.33599L5.9776 3.81313C5.90871 3.75025 5.85461 3.67592 5.81656 3.59559L7.62402 2.7394ZM7.32595 2.33599C7.2 2.22102 7.05132 2.13102 6.88757 2.07314L6.221 3.95879C6.12902 3.92628 6.04659 3.8761 5.9776 3.81313L7.32595 2.33599ZM6.88757 2.07314C6.72373 2.01522 6.54941 1.99111 6.37505 2.00292L6.51027 3.99835C6.41154 4.00504 6.31308 3.99134 6.221 3.95879L6.88757 2.07314ZM6.37505 2.00292C6.20071 2.01474 6.03171 2.0621 5.87787 2.14093L6.7899 3.92087C6.70405 3.96486 6.60897 3.99166 6.51027 3.99835L6.37505 2.00292ZM5.87787 2.14093C5.72413 2.2197 5.58947 2.32784 5.48028 2.45723L7.00877 3.74708C6.94958 3.81723 6.87565 3.87694 6.7899 3.92087L5.87787 2.14093ZM5.47929 2.45841L3.66339 4.617L5.19386 5.9045L7.00976 3.74591L5.47929 2.45841ZM5.14947 4.56765L4.21384 3.59455L2.77214 4.98074L3.70778 5.95384L5.14947 4.56765ZM4.21384 3.59455C4.09605 3.47204 3.95407 3.37268 3.79495 3.30413L3.00365 5.14094C2.9146 5.10257 2.8363 5.04746 2.77214 4.98073L4.21384 3.59455ZM3.79495 3.30413C3.63572 3.23554 3.46361 3.19967 3.28879 3.19967V5.19967C3.18981 5.19967 3.0928 5.17934 3.00365 5.14094L3.79495 3.30413ZM3.28879 3.19967C3.11396 3.19967 2.94185 3.23554 2.78262 3.30413L3.57392 5.14094C3.48477 5.17934 3.38776 5.19967 3.28879 5.19967V3.19967ZM2.78262 3.30413C2.6235 3.37268 2.48152 3.47204 2.36374 3.59455L3.80543 4.98073C3.74128 5.04746 3.66297 5.10257 3.57392 5.14094L2.78262 3.30413ZM2.36374 3.59455C2.24603 3.71697 2.15464 3.86019 2.09295 4.01508L3.95101 4.75508C3.91835 4.83709 3.86951 4.91409 3.80543 4.98073L2.36374 3.59455ZM2.09295 4.01508C2.03129 4.16991 2 4.33459 2 4.50002H4C4 4.58657 3.98365 4.67313 3.95101 4.75508L2.09295 4.01508ZM2 4.50002C2 4.66546 2.03129 4.83013 2.09295 4.98496L3.95101 4.24496C3.98365 4.32691 4 4.41347 4 4.50002H2ZM2.09295 4.98496C2.15464 5.13985 2.24603 5.28307 2.36374 5.40549L3.80543 4.01931C3.86951 4.08595 3.91835 4.16295 3.95101 4.24496L2.09295 4.98496ZM2.36374 5.40549L3.51742 6.60538L4.95912 5.21919L3.80543 4.01931L2.36374 5.40549ZM3.51789 6.60587C3.64081 6.73354 3.78996 6.83594 3.95727 6.90448L4.71547 5.05377C4.80926 5.0922 4.89163 5.1491 4.95864 5.2187L3.51789 6.60587ZM3.95727 6.90448C4.1247 6.97308 4.30535 7.00568 4.48754 6.99919L4.41635 5.00046C4.51958 4.99678 4.62155 5.0153 4.71547 5.05377L3.95727 6.90448ZM4.48754 6.99919C4.66972 6.9927 4.84732 6.94735 5.00905 6.8674L4.12273 5.07451C4.21311 5.02983 4.31314 5.00413 4.41635 5.00046L4.48754 6.99919ZM5.00905 6.8674C5.17064 6.78751 5.31185 6.67538 5.42535 6.54014L3.89338 5.25443C3.95492 5.1811 4.0325 5.11912 4.12273 5.07451L5.00905 6.8674ZM5.4245 6.54116L7.44345 4.14199L5.91318 2.85424L3.89423 5.25341L5.4245 6.54116Z"
        fill="#F5F5F5"
        mask="url(#path-4-inside-2_54_5172)"
      />
    </svg>
  );
};

export const PhoneIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5558_11824)">
        <path
          d="M3.27 2.5C3.3 2.945 3.375 3.38 3.495 3.795L2.895 4.395C2.69 3.795 2.56 3.16 2.515 2.5H3.27ZM8.2 8.51C8.625 8.63 9.06 8.705 9.5 8.735V9.48C8.84 9.435 8.205 9.305 7.6 9.105L8.2 8.51ZM3.75 1.5H2C1.725 1.5 1.5 1.725 1.5 2C1.5 6.695 5.305 10.5 10 10.5C10.275 10.5 10.5 10.275 10.5 10V8.255C10.5 7.98 10.275 7.755 10 7.755C9.38 7.755 8.775 7.655 8.215 7.47C8.165 7.45 8.11 7.445 8.06 7.445C7.93 7.445 7.805 7.495 7.705 7.59L6.605 8.69C5.19 7.965 4.03 6.81 3.31 5.395L4.41 4.295C4.55 4.155 4.59 3.96 4.535 3.785C4.35 3.225 4.25 2.625 4.25 2C4.25 1.725 4.025 1.5 3.75 1.5Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_5558_11824">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PDFIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.9375V13.25C14 13.7141 13.8194 14.1592 13.4979 14.4874C13.1764 14.8156 12.7404 15 12.2857 15H11.4286V14.125H12.2857C12.513 14.125 12.7311 14.0328 12.8918 13.8687C13.0526 13.7046 13.1429 13.4821 13.1429 13.25V4.9375H11.4286C11.0876 4.9375 10.7606 4.79922 10.5194 4.55308C10.2783 4.30694 10.1429 3.9731 10.1429 3.625V1.875H5.42857C5.20124 1.875 4.98323 1.96719 4.82248 2.13128C4.66173 2.29538 4.57143 2.51794 4.57143 2.75V10.625H3.71429V2.75C3.71429 2.28587 3.8949 1.84075 4.21639 1.51256C4.53788 1.18437 4.97391 1 5.42857 1H10.1429L14 4.9375ZM3.37143 11.3688H2V14.8679H2.678V13.6936H3.36629C3.61229 13.6936 3.82143 13.6437 3.99371 13.5422C4.16771 13.4399 4.30057 13.3016 4.39057 13.1275C4.48399 12.9448 4.53141 12.7412 4.52857 12.5351C4.52857 12.3164 4.48314 12.1186 4.39314 11.9427C4.30362 11.7679 4.16676 11.623 3.99886 11.5254C3.82743 11.4204 3.61914 11.3688 3.37143 11.3688ZM3.83857 12.5351C3.84166 12.6504 3.81662 12.7647 3.76571 12.8676C3.72004 12.9573 3.64894 13.0308 3.56171 13.0785C3.46193 13.1289 3.35156 13.1535 3.24029 13.1502H2.67543V11.92H3.24114C3.428 11.92 3.57457 11.9725 3.68 12.0784C3.78543 12.1851 3.83857 12.3374 3.83857 12.5351ZM4.88171 11.3688V14.8679H6.13314C6.47686 14.8679 6.76229 14.7979 6.98857 14.6605C7.21756 14.5206 7.39638 14.3093 7.49857 14.0576C7.61 13.7951 7.66657 13.4784 7.66657 13.1091C7.66657 12.7416 7.61086 12.4284 7.49857 12.1685C7.39758 11.9198 7.22048 11.711 6.99371 11.5735C6.76743 11.437 6.48029 11.3688 6.13229 11.3688H4.88171ZM5.55971 11.9331H6.04229C6.25486 11.9331 6.428 11.9769 6.56429 12.0661C6.70575 12.1606 6.81248 12.3003 6.86771 12.4634C6.93543 12.6392 6.96886 12.8589 6.96886 13.1222C6.97151 13.2968 6.95192 13.4709 6.91057 13.6403C6.88003 13.7738 6.82284 13.8995 6.74257 14.0095C6.66799 14.1076 6.56919 14.1837 6.45629 14.23C6.324 14.2805 6.1835 14.3049 6.04229 14.3018H5.55971V11.9331ZM8.768 13.4757V14.8679H8.09086V11.3688H10.2749V11.9401H8.768V12.9175H10.1446V13.4757H8.768Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const DocumentIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5572_13391)">
        <path
          d="M9.33398 2V4.66667C9.33398 4.84348 9.40422 5.01305 9.52925 5.13807C9.65427 5.2631 9.82384 5.33333 10.0007 5.33333H12.6673"
          stroke="#4E4E4E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2768 13.6095C12.0267 13.8595 11.6876 14 11.334 14H4.66732C4.3137 14 3.97456 13.8595 3.72451 13.6095C3.47446 13.3594 3.33398 13.0203 3.33398 12.6667V3.33333C3.33398 2.97971 3.47446 2.64057 3.72451 2.39052C3.97456 2.14048 4.3137 2 4.66732 2H9.33398L12.6673 5.33333V10.5"
          stroke="#4E4E4E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 11.3334H10"
          stroke="#4E4E4E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8.66663H10"
          stroke="#4E4E4E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {!props.removeTickIcon && (
          <path
            d="M14.0001 8.53596C14.6034 8.8843 15.1053 9.38417 15.456 9.98608C15.8068 10.588 15.9942 11.2711 15.9999 11.9677C16.0055 12.6643 15.8291 13.3503 15.4881 13.9578C15.1471 14.5653 14.6534 15.0732 14.0558 15.4313C13.4582 15.7893 12.7774 15.9851 12.0809 15.9992C11.3844 16.0133 10.6963 15.8452 10.0846 15.5117C9.47304 15.1781 8.95916 14.6906 8.59387 14.0974C8.22859 13.5042 8.02456 12.8258 8.002 12.1296L8 12L8.002 11.8704C8.0244 11.1796 8.22542 10.5063 8.58546 9.91635C8.9455 9.32637 9.45228 8.83974 10.0564 8.50391C10.6605 8.16808 11.3413 7.99452 12.0325 8.00013C12.7236 8.00575 13.4015 8.19036 14.0001 8.53596ZM13.4829 10.9172C13.414 10.8483 13.3223 10.8069 13.2251 10.8008C13.1279 10.7947 13.0318 10.8243 12.9549 10.884L12.9173 10.9172L11.6 12.234L11.0828 11.7172L11.0452 11.684C10.9683 11.6243 10.8722 11.5948 10.775 11.6009C10.6778 11.607 10.5862 11.6484 10.5173 11.7173C10.4485 11.7861 10.4071 11.8777 10.401 11.9749C10.3948 12.0721 10.4244 12.1682 10.484 12.2452L10.5172 12.2828L11.3172 13.0828L11.3548 13.116C11.425 13.1704 11.5113 13.1999 11.6 13.1999C11.6888 13.1999 11.7751 13.1704 11.8452 13.116L11.8828 13.0828L13.4829 11.4828L13.5161 11.4452C13.5758 11.3682 13.6053 11.2721 13.5992 11.1749C13.5931 11.0777 13.5517 10.986 13.4829 10.9172Z"
            fill="#00A000"
          />
        )}
      </g>
      {!props.removeTickIcon && (
        <defs>
          <clipPath id="clip0_5572_13391">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      )}
    </svg>
  );
};

export const MailIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "10"}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2 10C0.870001 10 0.587401 9.8775 0.352201 9.6325C0.117001 9.3875 -0.000398981 9.09333 1.01868e-06 8.75V1.25C1.01868e-06 0.906251 0.117601 0.611876 0.352801 0.366876C0.588001 0.121876 0.870401 -0.000415605 1.2 1.06112e-06H10.8C11.13 1.06112e-06 11.4126 0.122501 11.6478 0.367501C11.883 0.612501 12.0004 0.906668 12 1.25V8.75C12 9.09375 11.8824 9.38812 11.6472 9.63312C11.412 9.87812 11.1296 10.0004 10.8 10H1.2ZM10.8 2.5L6.315 5.42188C6.265 5.45313 6.2124 5.47667 6.1572 5.4925C6.102 5.50833 6.0496 5.51604 6 5.51562C5.95 5.51562 5.8974 5.50792 5.8422 5.4925C5.787 5.47708 5.7346 5.45354 5.685 5.42188L1.2 2.5V8.75H10.8V2.5ZM6 4.375L10.8 1.25H1.2L6 4.375ZM1.2 2.65625V1.73438V1.75V1.7425V2.65625Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg
      width={props.width || "8"}
      height={props.height || "12"}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2.7C4.37888 2.7 4.74224 2.85804 5.01015 3.13934C5.27806 3.42064 5.42857 3.80218 5.42857 4.2C5.42857 4.39698 5.39162 4.59204 5.31983 4.77403C5.24804 4.95601 5.14281 5.12137 5.01015 5.26066C4.8775 5.39995 4.72001 5.51044 4.54669 5.58582C4.37337 5.6612 4.1876 5.7 4 5.7C3.62112 5.7 3.25776 5.54197 2.98985 5.26066C2.72194 4.97936 2.57143 4.59783 2.57143 4.2C2.57143 3.80218 2.72194 3.42064 2.98985 3.13934C3.25776 2.85804 3.62112 2.7 4 2.7ZM4 0C5.06087 0 6.07828 0.442499 6.82843 1.23015C7.57857 2.0178 8 3.08609 8 4.2C8 7.35 4 12 4 12C4 12 0 7.35 0 4.2C0 3.08609 0.421427 2.0178 1.17157 1.23015C1.92172 0.442499 2.93913 0 4 0ZM4 1.2C3.24224 1.2 2.51551 1.51607 1.97969 2.07868C1.44388 2.64129 1.14286 3.40435 1.14286 4.2C1.14286 4.8 1.14286 6 4 10.026C6.85714 6 6.85714 4.8 6.85714 4.2C6.85714 3.40435 6.55612 2.64129 6.02031 2.07868C5.48449 1.51607 4.75776 1.2 4 1.2Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const FacebookIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_116_1062)">
        <path
          d="M23.04 0H0.96C0.429 0 0 0.429 0 0.96V23.04C0 23.571 0.429 24 0.96 24H23.04C23.571 24 24 23.571 24 23.04V0.96C24 0.429 23.571 0 23.04 0ZM20.268 7.005H18.351C16.848 7.005 16.557 7.719 16.557 8.769V11.082H20.145L19.677 14.703H16.557V24H12.816V14.706H9.687V11.082H12.816V8.412C12.816 5.313 14.709 3.624 17.475 3.624C18.801 3.624 19.938 3.723 20.271 3.768V7.005H20.268Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_116_1062">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InstagramIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_116_1071)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.05273 0.072C8.33236 0.0130909 8.74036 0 12 0C15.2596 0 15.6676 0.0141818 16.9462 0.072C18.2247 0.129818 19.0975 0.333818 19.8611 0.629455C20.6607 0.931636 21.3862 1.404 21.9862 2.01491C22.5971 2.61382 23.0684 3.33818 23.3695 4.13891C23.6662 4.90255 23.8691 5.77527 23.928 7.05164C23.9869 8.33346 24 8.74146 24 12C24 15.2596 23.9858 15.6676 23.928 16.9473C23.8702 18.2236 23.6662 19.0964 23.3695 19.86C23.0684 20.6608 22.5963 21.3864 21.9862 21.9862C21.3862 22.5971 20.6607 23.0684 19.8611 23.3695C19.0975 23.6662 18.2247 23.8691 16.9484 23.928C15.6676 23.9869 15.2596 24 12 24C8.74036 24 8.33236 23.9858 7.05273 23.928C5.77636 23.8702 4.90364 23.6662 4.14 23.3695C3.33919 23.0683 2.61362 22.5963 2.01382 21.9862C1.40332 21.3869 0.930889 20.6617 0.629455 19.8611C0.333818 19.0975 0.130909 18.2247 0.072 16.9484C0.0130909 15.6665 0 15.2585 0 12C0 8.74036 0.0141818 8.33236 0.072 7.05382C0.129818 5.77527 0.333818 4.90255 0.629455 4.13891C0.931334 3.33827 1.40413 2.61307 2.01491 2.01382C2.61386 1.40346 3.3387 0.931029 4.13891 0.629455C4.90255 0.333818 5.77527 0.130909 7.05164 0.072H7.05273ZM16.8491 2.232C15.5836 2.17418 15.204 2.16218 12 2.16218C8.796 2.16218 8.41636 2.17418 7.15091 2.232C5.98036 2.28545 5.34545 2.48073 4.92218 2.64545C4.36255 2.86364 3.96218 3.12218 3.54218 3.54218C3.14405 3.92951 2.83765 4.40104 2.64545 4.92218C2.48073 5.34545 2.28545 5.98036 2.232 7.15091C2.17418 8.41636 2.16218 8.796 2.16218 12C2.16218 15.204 2.17418 15.5836 2.232 16.8491C2.28545 18.0196 2.48073 18.6545 2.64545 19.0778C2.83745 19.5982 3.144 20.0705 3.54218 20.4578C3.92945 20.856 4.40182 21.1625 4.92218 21.3545C5.34545 21.5193 5.98036 21.7145 7.15091 21.768C8.41636 21.8258 8.79491 21.8378 12 21.8378C15.2051 21.8378 15.5836 21.8258 16.8491 21.768C18.0196 21.7145 18.6545 21.5193 19.0778 21.3545C19.6375 21.1364 20.0378 20.8778 20.4578 20.4578C20.856 20.0705 21.1625 19.5982 21.3545 19.0778C21.5193 18.6545 21.7145 18.0196 21.768 16.8491C21.8258 15.5836 21.8378 15.204 21.8378 12C21.8378 8.796 21.8258 8.41636 21.768 7.15091C21.7145 5.98036 21.5193 5.34545 21.3545 4.92218C21.1364 4.36255 20.8778 3.96218 20.4578 3.54218C20.0705 3.14408 19.5989 2.83768 19.0778 2.64545C18.6545 2.48073 18.0196 2.28545 16.8491 2.232ZM10.4673 15.6993C11.3233 16.0556 12.2764 16.1037 13.1639 15.8353C14.0514 15.567 14.8182 14.9988 15.3334 14.2279C15.8485 13.457 16.0801 12.5311 15.9884 11.6085C15.8968 10.6858 15.4876 9.82361 14.8309 9.16909C14.4123 8.7507 13.906 8.43034 13.3487 8.23107C12.7914 8.0318 12.1968 7.95858 11.6078 8.01667C11.0188 8.07477 10.45 8.26274 9.94233 8.56705C9.43468 8.87136 9.00081 9.28445 8.67197 9.77657C8.34312 10.2687 8.12748 10.8276 8.04056 11.413C7.95365 11.9985 7.99762 12.596 8.16932 13.1624C8.34101 13.7288 8.63616 14.2501 9.03351 14.6888C9.43087 15.1275 9.92054 15.4726 10.4673 15.6993ZM7.63855 7.63855C8.2113 7.06579 8.89126 6.61146 9.6396 6.30149C10.3879 5.99151 11.19 5.83197 12 5.83197C12.81 5.83197 13.6121 5.99151 14.3604 6.30149C15.1087 6.61146 15.7887 7.06579 16.3615 7.63855C16.9342 8.2113 17.3885 8.89126 17.6985 9.6396C18.0085 10.3879 18.168 11.19 18.168 12C18.168 12.81 18.0085 13.6121 17.6985 14.3604C17.3885 15.1087 16.9342 15.7887 16.3615 16.3615C15.2047 17.5182 13.6359 18.168 12 18.168C10.3641 18.168 8.79528 17.5182 7.63855 16.3615C6.48182 15.2047 5.83197 13.6359 5.83197 12C5.83197 10.3641 6.48182 8.79528 7.63855 7.63855ZM19.536 6.75055C19.6779 6.61666 19.7916 6.45565 19.8701 6.27706C19.9487 6.09847 19.9907 5.90593 19.9935 5.71083C19.9964 5.51574 19.9601 5.32205 19.8867 5.14125C19.8134 4.96044 19.7045 4.79619 19.5665 4.65822C19.4285 4.52026 19.2643 4.41137 19.0835 4.33802C18.9027 4.26467 18.709 4.22834 18.5139 4.23118C18.3188 4.23403 18.1263 4.27599 17.9477 4.35458C17.7691 4.43317 17.6081 4.54679 17.4742 4.68873C17.2138 4.96476 17.0712 5.33141 17.0768 5.71083C17.0823 6.09026 17.2355 6.4526 17.5038 6.72092C17.7721 6.98924 18.1345 7.14243 18.5139 7.14796C18.8933 7.15349 19.26 7.01093 19.536 6.75055Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_116_1071">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedInIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 1.76471V22.2353C24 22.7033 23.8141 23.1522 23.4831 23.4831C23.1522 23.8141 22.7033 24 22.2353 24H1.76471C1.29668 24 0.847817 23.8141 0.51687 23.4831C0.185924 23.1522 0 22.7033 0 22.2353L0 1.76471C0 1.29668 0.185924 0.847817 0.51687 0.51687C0.847817 0.185924 1.29668 0 1.76471 0L22.2353 0C22.7033 0 23.1522 0.185924 23.4831 0.51687C23.8141 0.847817 24 1.29668 24 1.76471ZM7.05882 9.17647H3.52941V20.4706H7.05882V9.17647ZM7.37647 5.29412C7.37833 5.02715 7.32759 4.76242 7.22714 4.51506C7.12669 4.2677 6.9785 4.04255 6.79103 3.85246C6.60357 3.66237 6.38049 3.51107 6.13455 3.4072C5.88861 3.30332 5.62462 3.24891 5.35765 3.24706H5.29412C4.7512 3.24706 4.23053 3.46273 3.84663 3.84663C3.46273 4.23053 3.24706 4.7512 3.24706 5.29412C3.24706 5.83703 3.46273 6.35771 3.84663 6.74161C4.23053 7.1255 4.7512 7.34118 5.29412 7.34118C5.56111 7.34774 5.82678 7.30164 6.07594 7.2055C6.32511 7.10936 6.55289 6.96506 6.74627 6.78086C6.93965 6.59666 7.09484 6.37616 7.20297 6.13196C7.3111 5.88775 7.37006 5.62464 7.37647 5.35765V5.29412ZM20.4706 13.6094C20.4706 10.2141 18.3106 8.89412 16.1647 8.89412C15.4621 8.85894 14.7626 9.00858 14.1358 9.32814C13.5091 9.64769 12.9771 10.126 12.5929 10.7153H12.4941V9.17647H9.17647V20.4706H12.7059V14.4635C12.6549 13.8483 12.8487 13.2378 13.2452 12.7646C13.6417 12.2915 14.2089 11.9939 14.8235 11.9365H14.9576C16.08 11.9365 16.9129 12.6424 16.9129 14.4212V20.4706H20.4424L20.4706 13.6094Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const MediumIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5374 11.2499C13.5374 7.52202 10.5069 4.5 6.76884 4.5C3.03073 4.5 0 7.5227 0 11.2499C0 14.9771 3.0305 18 6.76884 18C10.5072 18 13.5374 14.9778 13.5374 11.2499ZM20.9628 11.2499C20.9628 7.7409 19.4476 4.89518 17.5784 4.89518C15.7092 4.89518 14.194 7.7409 14.194 11.2499C14.194 14.7589 15.709 17.6046 17.5782 17.6046C19.4474 17.6046 20.9626 14.7598 20.9626 11.2499H20.9628ZM24 11.2499C24 8.1067 23.4672 5.55707 22.8097 5.55707C22.1522 5.55707 21.6196 8.10601 21.6196 11.2499C21.6196 14.3938 22.1524 16.9427 22.8097 16.9427C23.4669 16.9427 24 14.394 24 11.2499Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const TwitterIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 4.37236C23.1174 4.77326 22.1693 5.04414 21.1726 5.16658C22.201 4.53575 22.9704 3.5429 23.3373 2.37329C22.371 2.96162 21.3135 3.37575 20.2107 3.59766C19.4691 2.78596 18.4868 2.24796 17.4164 2.06717C16.3459 1.88638 15.2472 2.07293 14.2907 2.59785C13.3343 3.12277 12.5737 3.95669 12.127 4.97014C11.6803 5.98359 11.5725 7.11988 11.8203 8.20257C9.86244 8.1018 7.94711 7.58015 6.19863 6.67147C4.45016 5.76279 2.90761 4.48739 1.6711 2.92805C1.2483 3.67567 1.0052 4.54248 1.0052 5.46563C1.00473 6.29667 1.20437 7.11499 1.58641 7.84798C1.96846 8.58096 2.52109 9.20594 3.19528 9.66748C2.4134 9.64198 1.64877 9.42541 0.965031 9.03579V9.1008C0.964952 10.2664 1.35827 11.3961 2.07823 12.2982C2.7982 13.2004 3.80048 13.8194 4.915 14.0503C4.18968 14.2515 3.42923 14.2811 2.69109 14.137C3.00555 15.1399 3.61807 16.0169 4.44291 16.6452C5.26776 17.2735 6.26363 17.6217 7.29111 17.641C5.5469 19.0446 3.39282 19.806 1.17537 19.8026C0.782575 19.8027 0.39011 19.7792 0 19.7322C2.25083 21.2157 4.87097 22.003 7.5469 22C16.6053 22 21.5573 14.3092 21.5573 7.63915C21.5573 7.42245 21.552 7.20358 21.5425 6.98687C22.5057 6.27281 23.3372 5.38858 23.9979 4.37562L24 4.37236Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const WhatsappIcon = (props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_116_1068)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.415 14.382C17.117 14.233 15.656 13.515 15.384 13.415C15.112 13.316 14.914 13.267 14.715 13.565C14.517 13.861 13.948 14.531 13.775 14.729C13.601 14.928 13.428 14.952 13.131 14.804C12.834 14.654 11.876 14.341 10.741 13.329C9.858 12.541 9.261 11.568 9.088 11.27C8.915 10.973 9.069 10.812 9.218 10.664C9.352 10.531 9.515 10.317 9.664 10.144C9.813 9.96998 9.862 9.84598 9.961 9.64698C10.061 9.44898 10.011 9.27598 9.936 9.12698C9.862 8.97798 9.268 7.51498 9.02 6.91998C8.779 6.34098 8.534 6.41998 8.352 6.40998C8.178 6.40198 7.98 6.39998 7.782 6.39998C7.584 6.39998 7.262 6.47398 6.99 6.77198C6.717 7.06898 5.95 7.78798 5.95 9.25098C5.95 10.713 7.014 12.126 7.163 12.325C7.312 12.523 9.258 15.525 12.239 16.812C12.949 17.118 13.502 17.301 13.933 17.437C14.645 17.664 15.293 17.632 15.805 17.555C16.375 17.47 17.563 16.836 17.811 16.142C18.058 15.448 18.058 14.853 17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382H17.415ZM11.993 21.785H11.989C10.2184 21.7853 8.48037 21.3093 6.957 20.407L6.597 20.193L2.855 21.175L3.854 17.527L3.619 17.153C2.62914 15.5773 2.10529 13.7538 2.108 11.893C2.11 6.44298 6.544 2.00898 11.997 2.00898C14.637 2.00898 17.119 3.03898 18.985 4.90698C19.9054 5.82356 20.6349 6.91355 21.1313 8.11388C21.6277 9.31421 21.8811 10.6011 21.877 11.9C21.875 17.35 17.441 21.785 11.993 21.785ZM20.405 3.48798C19.3032 2.3789 17.9922 1.49952 16.5481 0.90078C15.1039 0.302044 13.5553 -0.00413728 11.992 -2.00576e-05C5.438 -2.00576e-05 0.102 5.33498 0.1 11.892C0.099 13.988 0.646 16.034 1.687 17.837L0 24L6.304 22.346C8.04787 23.2961 10.0021 23.7939 11.988 23.794H11.993C18.547 23.794 23.883 18.459 23.885 11.901C23.8898 10.3383 23.5848 8.79008 22.9874 7.34601C22.3901 5.90195 21.5124 4.59065 20.405 3.48798Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_116_1068">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EyeCloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 11.6667C5.58182 11.6667 3.41818 10.2667 2.4 8H1C2.08182 10.9333 4.81818 13 8 13C11.1818 13 13.9182 10.9333 15 8H13.6C12.5818 10.2667 10.4182 11.6667 8 11.6667Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const EyeOpenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 4.33333C5.58182 4.33333 3.41818 5.73333 2.4 8H1C2.08182 5.06667 4.81818 3 8 3C11.1818 3 13.9182 5.06667 15 8H13.6C12.5818 5.73333 10.4182 4.33333 8 4.33333Z"
        fill="#4E4E4E"
      />
      <circle cx="8" cy="10" r="2" fill="#4E4E4E" />
    </svg>
  );
};
export const VerifiedTick = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.29361 11.5C6.5502 11.7478 6.96622 11.7478 7.22281 11.5L12.3843 6.08331C12.6409 5.83549 12.6409 5.43369 12.3843 5.18587C12.1277 4.93804 11.7117 4.93805 11.4551 5.18587L7.22283 9.7051C6.96624 9.95292 6.55022 9.95292 6.29363 9.7051L4.12165 7.60256C3.86506 7.35473 3.44904 7.35473 3.19245 7.60256C2.93585 7.85038 2.93585 8.25218 3.19244 8.5L6.29361 11.5Z"
        fill="#00A000"
      />
    </svg>
  );
};

export const DoubleTickIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.6665 7.99996L7.99984 11.3333L14.6665 4.66663"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.3335 7.99996L4.66683 11.3333M8.00016 7.99996L11.3335 4.66663"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotificationsIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.42864 2.69384C6.42864 2.28249 6.5942 1.88798 6.8889 1.59711C7.1836 1.30623 7.5833 1.14282 8.00007 1.14282C8.41684 1.14282 8.81654 1.30623 9.11124 1.59711C9.40594 1.88798 9.5715 2.28249 9.5715 2.69384C10.4738 3.11497 11.243 3.7705 11.7967 4.5902C12.3503 5.40989 12.6676 6.36284 12.7144 7.3469V9.67344C12.7735 10.1556 12.9465 10.6173 13.2194 11.0214C13.4924 11.4255 13.8576 11.7607 14.2858 12H1.71436C2.14252 11.7607 2.50778 11.4255 2.78072 11.0214C3.05366 10.6173 3.22666 10.1556 3.28578 9.67344V7.3469C3.33258 6.36284 3.64981 5.40989 4.20346 4.5902C4.75711 3.7705 5.52632 3.11497 6.42864 2.69384Z"
      stroke={props.color || "#4E4E4E"}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.71436 12V12.7143C5.71436 13.2826 5.95517 13.8277 6.38383 14.2295C6.81248 14.6314 7.39386 14.8571 8.00007 14.8571C8.60628 14.8571 9.18766 14.6314 9.61631 14.2295C10.045 13.8277 10.2858 13.2826 10.2858 12.7143V12"
      stroke={props.color || "#4E4E4E"}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DefaultProfileIcon = (props) => (
  <svg
    width={props.size || "64"}
    height={props.size || "64"}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="32" fill="#F1F1F1" />
    <circle cx="31.9998" cy="32.0003" r="29.3333" fill="#F1F1F1" />
    <path
      d="M12.8384 54.2115V46.005C12.8384 39.4203 18.5576 34.0824 25.6126 34.0824H38.3868C45.4418 34.0824 51.161 39.4203 51.161 46.005V54.2115C46.0209 58.6498 39.3237 61.334 31.9997 61.334C24.6756 61.334 17.9785 58.6498 12.8384 54.2115Z"
      fill="#E5E5E5"
    />
    <path
      d="M43.8276 20.6459C43.8276 26.7602 38.5507 32.3792 31.9997 32.3792C25.4486 32.3792 20.1717 26.7602 20.1717 20.6459C20.1717 14.5315 25.4486 9.29102 31.9997 9.29102C38.5507 9.29102 43.8276 14.5315 43.8276 20.6459Z"
      fill="#E5E5E5"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.312 12.1004C11.1264 11.9149 10.8313 11.9034 10.6175 12.0555C9.62223 12.7637 8.40492 13.1802 7.09034 13.1802C3.72674 13.1802 1 10.4536 1 7.09009C1 3.72663 3.72674 1 7.09034 1C10.4539 1 13.1807 3.72663 13.1807 7.09009C13.1807 8.40488 12.764 9.62236 12.0555 10.6177C11.9033 10.8315 11.9149 11.1266 12.1004 11.3122L14.8513 14.063C15.0495 14.2612 15.0495 14.5825 14.8513 14.7807L14.7807 14.8514C14.5825 15.0495 14.2612 15.0495 14.063 14.8514L11.312 12.1004ZM12.0641 7.09009C12.0641 9.83692 9.83727 12.0637 7.09034 12.0637C4.3434 12.0637 2.11656 9.83692 2.11656 7.09009C2.11656 4.34326 4.3434 2.11652 7.09034 2.11652C9.83727 2.11652 12.0641 4.34326 12.0641 7.09009Z"
      fill="#4E4E4E"
    />
  </svg>
);

export const CloseIcon = (props) => (
  <svg
    width={props.width || "16"}
    height={props.height || "16"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.06978 2.12048C2.90913 1.95984 2.64867 1.95984 2.48803 2.12048L2.12048 2.48803C1.95984 2.64867 1.95984 2.90913 2.12048 3.06978L7.05071 8L2.12048 12.9302C1.95984 13.0909 1.95984 13.3513 2.12048 13.512L2.48803 13.8795C2.64867 14.0402 2.90913 14.0402 3.06978 13.8795L8 8.94929L12.9302 13.8795C13.0909 14.0402 13.3513 14.0402 13.512 13.8795L13.8795 13.512C14.0402 13.3513 14.0402 13.0909 13.8795 12.9302L8.94929 8L13.8795 3.06978C14.0402 2.90913 14.0402 2.64867 13.8795 2.48803L13.512 2.12048C13.3513 1.95984 13.0909 1.95984 12.9302 2.12048L8 7.05071L3.06978 2.12048Z"
      fill={props.color || "#4E4E4E"}
    />
  </svg>
);

export const ScanIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.90625 4.1905V3.42859C1.90625 3.02446 2.06679 2.63687 2.35256 2.3511C2.63833 2.06533 3.02592 1.90479 3.43006 1.90479H4.95387"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.90625 11.8096V12.5715C1.90625 12.9756 2.06679 13.3632 2.35256 13.649C2.63833 13.9347 3.02592 14.0953 3.43006 14.0953H4.95387"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0469 1.90479H12.5707C12.9748 1.90479 13.3624 2.06533 13.6482 2.3511C13.934 2.63687 14.0945 3.02446 14.0945 3.42859V4.1905"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0469 14.0953H12.5707C12.9748 14.0953 13.3624 13.9347 13.6482 13.649C13.934 13.3632 14.0945 12.9756 14.0945 12.5715V11.8096"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66797 8H13.3346"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QRCodeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6423_2950)">
      <path
        d="M1.5 2.31255C1.5 2.09705 1.58561 1.89037 1.73799 1.73799C1.89037 1.58561 2.09705 1.5 2.31255 1.5H5.56275C5.77825 1.5 5.98492 1.58561 6.13731 1.73799C6.28969 1.89037 6.3753 2.09705 6.3753 2.31255V5.56275C6.3753 5.77825 6.28969 5.98492 6.13731 6.13731C5.98492 6.28969 5.77825 6.3753 5.56275 6.3753H2.31255C2.09705 6.3753 1.89037 6.28969 1.73799 6.13731C1.58561 5.98492 1.5 5.77825 1.5 5.56275V2.31255Z"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 2.31255C9.625 2.09705 9.71061 1.89037 9.86299 1.73799C10.0154 1.58561 10.222 1.5 10.4375 1.5H13.6877C13.9032 1.5 14.1099 1.58561 14.2623 1.73799C14.4147 1.89037 14.5003 2.09705 14.5003 2.31255V5.56275C14.5003 5.77825 14.4147 5.98492 14.2623 6.13731C14.1099 6.28969 13.9032 6.3753 13.6877 6.3753H10.4375C10.222 6.3753 10.0154 6.28969 9.86299 6.13731C9.71061 5.98492 9.625 5.77825 9.625 5.56275V2.31255Z"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 10.4375C1.5 10.222 1.58561 10.0154 1.73799 9.86299C1.89037 9.71061 2.09705 9.625 2.31255 9.625H5.56275C5.77825 9.625 5.98492 9.71061 6.13731 9.86299C6.28969 10.0154 6.3753 10.222 6.3753 10.4375V13.6877C6.3753 13.9032 6.28969 14.1099 6.13731 14.2623C5.98492 14.4147 5.77825 14.5003 5.56275 14.5003H2.31255C2.09705 14.5003 1.89037 14.4147 1.73799 14.2623C1.58561 14.1099 1.5 13.9032 1.5 13.6877V10.4375Z"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 9.625H12.0626"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 9.625V9.63375"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 9.625V12.0626"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 14.5H12.0626"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0625 12.0625H14.5001"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 12.0625V14.5001"
        stroke="#4E4E4E"
        strokeWidth="1.21882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6423_2950">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlusIconWithSquare = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 8H10"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V10"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333Z"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HistoryIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.7198 4.90041C14.514 6.03263 14.9615 7.38031 14.9976 8.77579C15.0398 10.4042 14.5194 11.9969 13.5249 13.2825C12.5306 14.5682 11.1236 15.4673 9.54407 15.8266C7.96443 16.1859 6.30984 15.9832 4.86221 15.253C3.41452 14.5228 2.26337 13.3103 1.60482 11.8222C0.946331 10.334 0.821162 8.66223 1.25077 7.09165C1.68031 5.52108 2.63805 4.14893 3.96069 3.20897C5.00931 2.46376 6.23591 2.02679 7.50408 1.93618C7.73602 1.91961 7.92336 1.72882 7.92336 1.49267V0.431613C7.92336 0.0874131 8.3011 -0.117848 8.58302 0.0731555L11.7391 2.21139C11.9909 2.38196 11.9909 2.75774 11.7391 2.92831L8.58302 5.06655C8.3011 5.25755 7.92336 5.05229 7.92336 4.70809V3.75891C7.92336 3.51865 7.7296 3.32316 7.494 3.34464C6.51733 3.43369 5.57526 3.7796 4.76568 4.35493C3.70658 5.10756 2.93978 6.20628 2.5958 7.46383C2.25182 8.72141 2.352 10.06 2.87931 11.2516C3.40662 12.4432 4.32836 13.4141 5.48752 13.9987C6.64669 14.5834 7.97156 14.7457 9.23633 14.458C10.5012 14.1703 11.6277 13.4504 12.4239 12.4209C13.2202 11.3915 13.6369 10.1162 13.6031 8.81237C13.5755 7.74616 13.248 6.71483 12.6656 5.83495C12.4501 5.50941 12.4779 5.06222 12.7712 4.80697C13.0605 4.55519 13.4987 4.58526 13.7198 4.90041Z"
        fill={props.color || "#959595"}
      />
      <path
        d="M7 6.75C7 6.33579 7.33579 6 7.75 6C8.16421 6 8.5 6.33579 8.5 6.75V9H9.25C9.66421 9 10 9.33579 10 9.75C10 10.1642 9.66421 10.5 9.25 10.5H7.75C7.38132 10.5 7 10.1879 7 9.8V6.75Z"
        fill={props.color || "#959595"}
      />
    </svg>
  );
};

export const TickIconWithCircle = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.41707 8.625C5.22462 8.81087 4.91261 8.81087 4.72016 8.625L2.39429 6.375C2.20184 6.18913 2.20185 5.88778 2.39429 5.70192C2.58673 5.51605 2.89875 5.51605 3.0912 5.70192L4.72018 7.27882C4.91262 7.46469 5.22463 7.46469 5.41708 7.27882L8.59128 3.8894C8.78373 3.70353 9.09574 3.70353 9.28819 3.8894C9.48063 4.07527 9.48064 4.37662 9.28819 4.56248L5.41707 8.625Z"
      fill="#00A000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM11.1 6C11.1 8.81665 8.81665 11.1 6 11.1C3.18335 11.1 0.9 8.81665 0.9 6C0.9 3.18335 3.18335 0.9 6 0.9C8.81665 0.9 11.1 3.18335 11.1 6Z"
      fill="#00A000"
    />
  </svg>
);

export function SuccessTickIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="40" height="40" fill="url(#pattern0_6898_7399)" />
      <defs>
        <pattern
          id="pattern0_6898_7399"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_6898_7399"
            transform="translate(-0.0128205) scale(0.00512821)"
          />
        </pattern>
        <image
          id="image0_6898_7399"
          width="200"
          height="195"
          preserveAspectRatio="none"
        />
      </defs>
    </svg>
  );
}

export const InfoFilledIcon = (props) => (
  <svg
    width={props.size || "40"}
    height={props.size || "40"}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0007 3.33325C29.2057 3.33325 36.6673 10.7949 36.6673 19.9999C36.6708 24.3757 34.9532 28.5773 31.8855 31.6977C28.8177 34.818 24.6459 36.6067 20.2707 36.6776C15.8955 36.7485 11.6679 35.0959 8.50065 32.0766C5.33341 29.0573 3.48063 24.9135 3.34232 20.5399L3.33398 19.9999L3.34065 19.5333C3.58732 10.5449 10.9507 3.33325 20.0007 3.33325ZM20.0007 18.3333H18.334L18.139 18.3449C17.7339 18.3931 17.3606 18.5882 17.0897 18.8932C16.8188 19.1982 16.6692 19.592 16.6692 19.9999C16.6692 20.4079 16.8188 20.8016 17.0897 21.1066C17.3606 21.4117 17.7339 21.6067 18.139 21.6549L18.334 21.6666V26.6666L18.3457 26.8616C18.3895 27.2336 18.5575 27.58 18.8223 27.8449C19.0872 28.1098 19.4336 28.2777 19.8057 28.3216L20.0007 28.3333H21.6673L21.8623 28.3216C22.2343 28.2777 22.5807 28.1098 22.8456 27.8449C23.1105 27.58 23.2784 27.2336 23.3223 26.8616L23.334 26.6666L23.3223 26.4716C23.2825 26.1315 23.1389 25.812 22.9111 25.5565C22.6832 25.3009 22.3822 25.1217 22.049 25.0433L21.8623 25.0099L21.6673 24.9999V19.9999L21.6557 19.8049C21.6118 19.4329 21.4439 19.0865 21.179 18.8216C20.9141 18.5567 20.5677 18.3888 20.1957 18.3449L20.0007 18.3333ZM20.0173 13.3333L19.8057 13.3449C19.4006 13.3931 19.0272 13.5882 18.7563 13.8932C18.4855 14.1982 18.3358 14.592 18.3358 14.9999C18.3358 15.4079 18.4855 15.8016 18.7563 16.1066C19.0272 16.4117 19.4006 16.6067 19.8057 16.6549L20.0007 16.6666L20.2123 16.6549C20.6174 16.6067 20.9907 16.4117 21.2616 16.1066C21.5325 15.8016 21.6821 15.4079 21.6821 14.9999C21.6821 14.592 21.5325 14.1982 21.2616 13.8932C20.9907 13.5882 20.6174 13.3931 20.2123 13.3449L20.0173 13.3333Z"
      fill="#959595"
    />
  </svg>
);

export const CameraIcon = (props) => (
  <svg
    width={props.size || "16"}
    height={props.size || "16"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7702_8343)">
      <path
        d="M3.33333 4.6665H4C4.35362 4.6665 4.69276 4.52603 4.94281 4.27598C5.19286 4.02593 5.33333 3.68679 5.33333 3.33317C5.33333 3.15636 5.40357 2.98679 5.5286 2.86177C5.65362 2.73674 5.82319 2.6665 6 2.6665H10C10.1768 2.6665 10.3464 2.73674 10.4714 2.86177C10.5964 2.98679 10.6667 3.15636 10.6667 3.33317C10.6667 3.68679 10.8071 4.02593 11.0572 4.27598C11.3072 4.52603 11.6464 4.6665 12 4.6665H12.6667C13.0203 4.6665 13.3594 4.80698 13.6095 5.05703C13.8595 5.30708 14 5.64622 14 5.99984V11.9998C14 12.3535 13.8595 12.6926 13.6095 12.9426C13.3594 13.1927 13.0203 13.3332 12.6667 13.3332H3.33333C2.97971 13.3332 2.64057 13.1927 2.39052 12.9426C2.14048 12.6926 2 12.3535 2 11.9998V5.99984C2 5.64622 2.14048 5.30708 2.39052 5.05703C2.64057 4.80698 2.97971 4.6665 3.33333 4.6665Z"
        stroke="#4E4E4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8.6665C6 9.19694 6.21071 9.70565 6.58579 10.0807C6.96086 10.4558 7.46957 10.6665 8 10.6665C8.53043 10.6665 9.03914 10.4558 9.41421 10.0807C9.78929 9.70565 10 9.19694 10 8.6665C10 8.13607 9.78929 7.62736 9.41421 7.25229C9.03914 6.87722 8.53043 6.6665 8 6.6665C7.46957 6.6665 6.96086 6.87722 6.58579 7.25229C6.21071 7.62736 6 8.13607 6 8.6665Z"
        stroke="#4E4E4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7702_8343">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FolderIcon = (props) => (
  <svg
    width={props.size || "16"}
    height={props.size || "16"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7702_8353)">
      <path
        d="M3.33333 2.6665H6L8 4.6665H12.6667C13.0203 4.6665 13.3594 4.80698 13.6095 5.05703C13.8595 5.30708 14 5.64622 14 5.99984V11.3332C14 11.6868 13.8595 12.0259 13.6095 12.276C13.3594 12.526 13.0203 12.6665 12.6667 12.6665H3.33333C2.97971 12.6665 2.64057 12.526 2.39052 12.276C2.14048 12.0259 2 11.6868 2 11.3332V3.99984C2 3.64622 2.14048 3.30708 2.39052 3.05703C2.64057 2.80698 2.97971 2.6665 3.33333 2.6665Z"
        stroke="#4E4E4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7702_8353">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10L10 6"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33301 4.00004L7.64167 3.64271C8.26688 3.01759 9.1148 2.66644 9.99891 2.6665C10.883 2.66657 11.7309 3.01784 12.356 3.64304C12.9811 4.26824 13.3323 5.11617 13.3322 6.00028C13.3321 6.88439 12.9809 7.73226 12.3557 8.35737L11.9997 8.66671"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66709 11.9999L8.40242 12.3559C7.76992 12.9814 6.91628 13.3322 6.02675 13.3322C5.13723 13.3322 4.28359 12.9814 3.65109 12.3559C3.33932 12.0477 3.09182 11.6806 2.92289 11.276C2.75397 10.8714 2.66699 10.4374 2.66699 9.99892C2.66699 9.56049 2.75397 9.12641 2.92289 8.72182C3.09182 8.31724 3.33932 7.95019 3.65109 7.64192L4.00042 7.33325"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UploadIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66699 11.333V12.6663C2.66699 13.02 2.80747 13.3591 3.05752 13.6091C3.30756 13.8592 3.6467 13.9997 4.00033 13.9997H12.0003C12.3539 13.9997 12.6931 13.8592 12.9431 13.6091C13.1932 13.3591 13.3337 13.02 13.3337 12.6663V11.333"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66699 6.00033L8.00033 2.66699L11.3337 6.00033"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2.6665V10.6665"
      stroke="#4E4E4E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrashIcon = (props) => (
  <svg
    width={props.width || 36}
    height={props.height || 36}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.35C16.5 21.15 20 16.25 20 11V5L12 2z"
      stroke={props.color || "#d32f2f"}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13 7l-3 5h4l-3 5"
      stroke={props.color || "#d32f2f"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = (props) => (
  <svg
    width={props.width || 16}
    height={props.height || 16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V5.66667C7 6.40305 6.40305 7 5.66667 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H5.66667C6.40305 9 7 9.59695 7 10.3333V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V10.3333C9 9.59695 9.59695 9 10.3333 9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H10.3333C9.59695 7 9 6.40305 9 5.66667V1Z"
      fill="#00A000"
    />
  </svg>
);

export const ConsentRequiredFallback = () => (
  <svg
    width="148"
    height="120"
    viewBox="0 0 148 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 85.0001C0 85.0001 51.1394 82.9562 61.9868 48.0005L39.5395 52.5051C39.5395 52.5051 35.4057 65.7413 28.995 72.7463C28.995 72.7463 26.1805 73.7187 14.4437 69.4422L0 85.0001Z"
      fill="#F1F1F1"
    />
    <path
      d="M14.4418 69.4322C14.4613 69.3925 15.2138 69.7199 16.6015 70.2458C17.9794 70.7816 20.0316 71.4364 22.6116 71.9326C25.2013 72.4187 28.3578 72.6966 31.8172 72.3493C35.2767 72.0119 39.0293 71.0098 42.6158 69.1841C49.8475 65.5427 55.0757 60.0558 58.027 55.6603C59.5125 53.4476 60.4897 51.5128 61.0858 50.1435C61.6722 48.7644 61.9458 47.9805 61.9947 48.0004C62.0142 48.0103 61.9556 48.2087 61.8383 48.5858C61.7113 48.9628 61.5647 49.5284 61.2715 50.2229C60.734 51.6319 59.7959 53.6064 58.33 55.8686C55.4276 60.3633 50.1797 65.9594 42.8504 69.6505C39.2052 71.5059 35.3842 72.518 31.8759 72.8255C28.3578 73.153 25.1622 72.8355 22.5627 72.2997C19.9535 71.744 17.911 71.0296 16.5429 70.4343C15.849 70.1664 15.3408 69.8886 14.9793 69.7199C14.6177 69.5413 14.432 69.4421 14.4418 69.4322Z"
      fill="#959595"
    />
    <path
      d="M54.9895 56.8609C55.0091 56.9204 54.1882 57.2975 52.8103 57.7936C51.4324 58.2897 49.5072 58.9049 47.3377 59.4506C45.1682 59.9963 43.1844 60.3634 41.7381 60.5817C40.2917 60.7901 39.3927 60.8496 39.3829 60.7901C39.3731 60.7206 40.2526 60.5321 41.6794 60.2245C43.1062 59.9268 45.0705 59.5002 47.2204 58.9545C49.3704 58.4087 51.3053 57.863 52.7028 57.4463C54.0905 57.0494 54.9602 56.7914 54.9895 56.8609Z"
      fill="#959595"
    />
    <path
      d="M52.4583 61.6137C52.4778 61.6732 51.657 62.0502 50.279 62.5463C48.9011 63.0424 46.9759 63.6576 44.8064 64.2033C42.637 64.7491 40.6531 65.1162 39.2068 65.3345C37.7605 65.5428 36.8614 65.6024 36.8516 65.5428C36.8419 65.4734 37.7214 65.2849 39.1482 64.9773C40.575 64.6796 42.5392 64.253 44.6892 63.7072C46.8391 63.1615 48.7741 62.6158 50.1715 62.1991C51.569 61.7923 52.429 61.5442 52.4583 61.6137Z"
      fill="#959595"
    />
    <path
      d="M78.002 73.1087C78.002 73.1087 94.5485 112.93 122.113 119.728C122.113 119.728 139.198 109.889 147.442 107.532C147.442 107.532 116.245 83.9957 110.207 62.4131C110.207 62.4131 98.1812 77.117 78.002 73.1087Z"
      fill="#F1F1F1"
    />
    <path
      d="M78.0015 73.1085C78.0015 73.1085 78.2011 73.1287 78.6103 73.179C79.0494 73.2395 79.6582 73.3099 80.4466 73.4107C80.8557 73.461 81.3148 73.5416 81.8138 73.5819C82.3128 73.602 82.8617 73.6222 83.4505 73.6423C84.0393 73.6524 84.678 73.7027 85.3566 73.6927C86.0353 73.6524 86.7538 73.602 87.5223 73.5517C90.5661 73.2898 94.2786 72.5546 98.2406 70.7921C100.227 69.9462 102.243 68.788 104.258 67.3881C106.254 65.9781 108.27 64.3164 110.047 62.282L110.296 62L110.396 62.3626C112.612 70.0469 117.801 77.8218 124.248 85.345C130.755 92.8581 138.619 100.281 147.411 107.189L147.591 107.33L148 107.643L147.501 107.794C145.156 108.489 142.9 109.435 140.695 110.412C138.499 111.399 136.344 112.437 134.248 113.494C130.046 115.619 126.024 117.784 122.222 119.95L122.132 120L122.042 119.98C117.372 118.761 113.111 116.757 109.408 114.29C105.696 111.832 102.462 109.032 99.6378 106.192C93.9892 100.472 89.8775 94.6307 86.7139 89.6756C83.5603 84.7005 81.4146 80.531 80.0075 77.6406C79.3089 76.2004 78.7999 75.0623 78.4706 74.2969C78.3209 73.9243 78.1911 73.6322 78.1013 73.4207C78.0315 73.2193 77.9915 73.0985 78.0015 73.1085C78.0115 73.1186 78.0614 73.1992 78.1512 73.4006C78.251 73.6121 78.3808 73.8941 78.5504 74.2566C78.9097 75.012 79.4386 76.1299 80.1572 77.56C81.6142 80.4202 83.7998 84.5595 86.9834 89.4944C90.1669 94.4192 94.3086 100.21 99.9472 105.88C102.771 108.7 105.995 111.46 109.677 113.887C113.35 116.324 117.572 118.298 122.182 119.486L122.003 119.517C125.815 117.341 129.837 115.166 134.038 113.031C136.144 111.963 138.3 110.926 140.505 109.929C142.721 108.942 144.986 107.985 147.371 107.28L147.291 107.743L147.112 107.602C138.28 100.663 130.416 93.2207 123.889 85.6572C117.422 78.0938 112.222 70.2584 110.017 62.4633L110.366 62.5338C108.54 64.6084 106.504 66.2702 104.478 67.6802C102.442 69.08 100.396 70.2382 98.3803 71.0741C94.3684 72.8265 90.616 73.5315 87.5522 73.7632C86.7838 73.8034 86.0552 73.8437 85.3766 73.8739C84.698 73.8739 84.0493 73.8135 83.4605 73.7934C82.8717 73.7632 82.3228 73.7329 81.8138 73.7128C81.3148 73.6624 80.8857 73.5718 80.4865 73.5114C79.6981 73.3804 79.0993 73.2797 78.6602 73.2092C78.2311 73.1488 78.0015 73.1085 78.0015 73.1085Z"
      fill="#959595"
    />
    <path
      d="M112.273 76.0392C112.253 76.0392 112.353 76.009 112.303 76.0896C112.273 76.1299 112.223 76.1702 112.153 76.2104C112.014 76.3011 111.804 76.4219 111.525 76.5629C110.976 76.8449 110.157 77.2176 109.149 77.6607C107.123 78.547 104.309 79.7152 101.185 80.954C98.0518 82.1927 95.2075 83.2804 93.1417 84.0358C91.0659 84.7911 89.7785 85.2242 89.7486 85.1637C89.7186 85.0932 90.9661 84.5393 93.012 83.6933C95.0478 82.8474 97.8721 81.7093 101.006 80.4706C104.07 79.2721 106.844 78.1844 109.02 77.3284C111.046 76.5428 112.393 76.0292 112.273 76.0392Z"
      fill="#959595"
    />
    <path
      d="M114.307 80.9339C114.367 81.0648 109.856 83.4416 104.228 86.2313C98.5991 89.0311 93.9784 91.1964 93.9186 91.0655C93.8587 90.9346 98.3696 88.5578 103.998 85.758C109.627 82.9682 114.247 80.8029 114.307 80.9339Z"
      fill="#959595"
    />
    <path
      d="M118.22 85.3451C118.29 85.4659 113.899 88.1348 108.42 91.2972C102.931 94.4595 98.4301 96.9169 98.3602 96.796C98.2903 96.6752 102.681 94.0063 108.17 90.844C113.649 87.6816 118.15 85.2242 118.22 85.3451Z"
      fill="#959595"
    />
    <path
      d="M133.279 100.331C133.349 100.452 129.188 103.101 123.968 106.243C118.749 109.385 114.467 111.832 114.388 111.712C114.318 111.591 118.479 108.942 123.699 105.8C128.918 102.648 133.21 100.2 133.279 100.331Z"
      fill="#959595"
    />
    <path
      d="M48 21.2C48 21.2 71.1142 7.68797 76.6084 0.244141C76.6084 0.244141 106.836 14.8879 133.237 6.40993L112.957 30.2146C112.957 30.2146 80.0013 37.3755 48 21.2Z"
      fill="#F1F1F1"
    />
    <path
      d="M48.0013 21.1998C48.4833 21.4144 49.7845 21.99 52.5702 23.2193C53.9967 23.9217 55.886 24.5461 58.0451 25.3754C60.1946 26.2631 62.7682 26.907 65.5828 27.7948C71.289 29.307 78.2869 30.6924 86.3258 31.268C87.3282 31.3655 88.3499 31.4143 89.3813 31.4436C90.4127 31.4826 91.4633 31.5216 92.5236 31.5607C94.6442 31.5509 96.8322 31.5899 99.0588 31.4729C103.512 31.2777 108.177 30.8972 112.91 29.9802L112.775 30.0582C118.655 23.151 125.055 15.6291 131.696 7.82431C132.149 7.28773 132.602 6.76091 133.046 6.24384L133.316 6.65359C127.985 8.2926 122.559 9.06332 117.286 9.24869C115.966 9.25844 114.655 9.2682 113.353 9.27796C112.062 9.19991 110.77 9.13161 109.498 9.05357C108.216 9.01454 106.972 8.79991 105.719 8.67308C105.093 8.59504 104.476 8.52674 103.859 8.4487C103.242 8.36089 102.635 8.24382 102.028 8.14626C97.1792 7.37554 92.5911 6.22433 88.3307 4.89751C84.0703 3.56094 80.099 2.09754 76.5133 0.429264L76.7543 0.370728C75.0482 2.57558 73.024 4.25362 71.1252 5.82433C69.2166 7.39505 67.3274 8.76089 65.5538 10.0389C61.9971 12.5657 58.8259 14.6145 56.2233 16.2633C53.6112 17.912 51.5581 19.151 50.1604 19.9803C49.4664 20.3803 48.9363 20.6925 48.5507 20.9071C48.1941 21.112 48.011 21.19 48.0013 21.1998C47.982 21.2095 48.1748 21.073 48.5315 20.8486C48.9074 20.6144 49.4279 20.2925 50.1122 19.873C51.5003 19.0144 53.5341 17.7462 56.1173 16.0681C58.7006 14.3901 61.8525 12.3218 65.3803 9.77551C67.1346 8.48772 69.0142 7.11212 70.9131 5.54141C72.7927 3.97069 74.8072 2.2829 76.4555 0.126828L76.5519 0L76.6965 0.068292C80.2532 1.7073 84.2245 3.16094 88.4656 4.46825C92.7164 5.78531 97.2852 6.90725 102.114 7.66822C102.722 7.76578 103.319 7.88285 103.936 7.97065C104.553 8.03894 105.17 8.11699 105.787 8.18528C107.03 8.31211 108.274 8.51699 109.536 8.55601C110.799 8.6243 112.081 8.70235 113.373 8.77064C114.664 8.76089 115.966 8.75113 117.276 8.74137C122.51 8.55601 127.889 7.78529 133.171 6.16579L134 5.91214L133.431 6.57554C132.988 7.09261 132.535 7.61943 132.082 8.15601C125.431 15.9511 119.031 23.4632 113.141 30.3704L113.083 30.4387L113.006 30.4485C108.216 31.3655 103.551 31.7363 99.0685 31.9216C96.8322 32.0387 94.6442 31.9899 92.514 31.9899C91.444 31.9509 90.3934 31.9021 89.362 31.8631C88.321 31.8338 87.2993 31.7753 86.2969 31.6777C78.2387 31.0729 71.2215 29.6387 65.5056 28.0875C62.6911 27.1802 60.1078 26.507 57.968 25.5997C55.8089 24.751 53.9389 24.1071 52.4738 23.3559C49.746 22.0388 48.464 21.4242 48.0013 21.1998Z"
      fill="#959595"
    />
    <path
      d="M82.9333 7.59971C83.02 7.70702 78.9331 11.1899 73.8148 15.3752C68.6869 19.5606 64.4651 22.8678 64.3783 22.7605C64.2916 22.6532 68.3785 19.1703 73.4967 14.9752C78.615 10.7997 82.8465 7.49239 82.9333 7.59971Z"
      fill="#959595"
    />
    <path
      d="M88.8797 8.86809C88.9761 8.96565 85.2458 12.7022 80.542 17.19C75.8382 21.6875 71.9537 25.2484 71.8573 25.1509C71.7609 25.0533 75.4912 21.3167 80.195 16.8192C84.8988 12.3217 88.7833 8.76077 88.8797 8.86809Z"
      fill="#959595"
    />
    <path
      d="M94.1325 10.9172C94.2385 11.005 91.3082 14.6244 87.5876 18.9951C83.867 23.3658 80.7729 26.8389 80.6669 26.7414C80.5608 26.6536 83.4911 23.0341 87.2117 18.6634C90.9323 14.3025 94.0264 10.8294 94.1325 10.9172Z"
      fill="#959595"
    />
    <path
      d="M101.652 11.3655C101.758 11.4533 99.1939 15.0826 95.9166 19.4728C92.6394 23.863 89.8826 27.3556 89.7766 27.2776C89.6706 27.1898 92.2345 23.5605 95.5214 19.1703C98.7987 14.7801 101.546 11.2875 101.652 11.3655Z"
      fill="#959595"
    />
  </svg>
);